import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { Alert } from "../../common/Alert";
import BeforeClosePrompt from "../../common/BeforeClosePrompt/BeforeClosePrompt";
import AppCalendar from "../../common/Calendar";
import { ALLOWABLE_BOOKING_DATE } from "../../configs/appConfigs";
import infoicon from "../../../src/assets/images/infoicon.png";
import { getUnidInfo } from "../../services/dgBookingServices";
import { deletespecialcommodityattachment } from "../../services/dgBookingServices";
import {
	getToastSuccess,
	getToastError,
} from "../../redux/actions/toastActions";
import {
	validateMutlipleBookingFlightData,
	validateSeasonalBooking,
} from "./formUtils";
import errorFilledOrange from "../../assets/images/errorFilledOrange.svg";

import {
	AUTOCOMPLETE_TYPE,
	AUTOCOMPLETE_UNID,
	DIMENSION_UNIT,
	FORM_FIELDS,
	FRESH_FORWARD_PRODUCT,
	getInitLooseItemDetail,
	getInitPharmaObject,
	getInitULDItemDetail,
	PHARMA_PRODUCT,
	PHARMA_SHIPPING_TYPE,
	IS_KNOWN_UNKNOWN,
	PRICE_CODE_TYPE,
	SCC_CODES,
	SHIPPING_TYPE,
	VALIDATE_BOOKINGS_ERROR_CODES,
	WEIGHT_UNIT,
	NOTIFICATION_MESSAGE_TYPE,
	SYSTEM_ADDED_SCCS,
	PAGE_PRIMARY_CATEGORY,
	PAGE_SUB_CATEGORY1,
	getInitUnidDetail,
	getRoundedValue,
	getRoundedValueDecimal,
	LOOSE_ITEM_KEYS,
	getInitCageDetails,
	DETAILS_APPLY_FOR,
	BOOKING_PAGE_SUB_CATEGORY2,
	SEARCH_DATE_TOGGLE_TYPE,
	PHARMA_TEMP_RANGE,
} from "../../constants";
import { calculateWeightToKg, checkForBupLooseRestriction, checkIsApplyLooseRestriction, round } from "../../utils/common";
import {
	getPromoCodeResponse,
	getValidateSpotRateResponse,
	validateUpdateBooking,
} from "../../services/quoteServices";
import {
	checkSccCompatibility,
	getAirportsByCode,
	getServices,
	getShippingItems,
	getSccMaster,
} from "../../services/searchPanelServices";
import {
	reprocessPermanentbooking,
	saveSeasonalBooking,
} from "../../services/permanentService";
import { getAviBookingBreeds } from "../../services/aviBookingService";
import {
	clearItemFromSessionStorage,
	getBase64Decoded,
	getBase64Encoded,
	getFromSessionStorage,
	setToSessionStorage,
	getFromLocalStorage,
} from "../../utils/StorageUtils";
import AdditionalInfoForm from "../AdditionalInfoForm";
import AirportAutocomplete from "../AirportAutocomplete";
import LoadingIndicator from "../LoadingIndicator";
import LooseItemForm from "../LooseItemForm";
import RecommendedSccList from "../RecommendedSccList/RecommendedSccList";
import SccAutoComplete from "../SccAutoComplete";
import SccListDisplay from "../SccListDisplay";
import SearchSummary from "../SearchSummary/SearchSummary";
import ShippingItemAutocomplete from "../ShippingItemAutocomplete";
import ULDItemForm from "../ULDItemForm";
import ContainerValidationPopUp from "./ContainerValidationPopUp";
import {
	checkIsBackButtonAction,
	handleTilteableAndStackable,
	validateFormData,
	checkIsBigOrOHG,
} from "./formUtils";
import "./search-panel.scss";
import SearchButtonGroup from "./SearchButtonGroup";
import SeasonalButtonGroup from "../SeasonalBooking/SeasonalButtonGroup";
import SchedulerMultiFlightsContainer from "../SeasonalBooking/schedulerMultiFlightsContainer";
import SearchHeader from "./SearchHeader";
import ShippingItemValidationPopUp from "./ShippingItemValidationPopUp";
import AviShippingItemValidationPopUp from "./AviShippingItemValidationPopUp";
import {
	getBookingFlightDetails,
	removeDuplicates,
	updateTemplateDetails,
} from "./templateUtils";
import MESSAGES from "../../constants/Messages";
import { convertToLowerCase } from "../../utils/common";
import getCurrentUser from "../../utils/getCurrentUser";
import {
	EYP_SCC,
	EXCEPTION_SCCS,
	OHG_SCC,
	BIG_SCC,
	FORCE_QUEUE_SCC,
} from "../../constants/sccTypes";
import { useTranslation } from "react-i18next";
import { UNKNOWN_SHIPPER_ENABLED } from "../../configs/featureControlConfig";
import {
	addError,
	pushPageData,
	updatePromoCodeError,
} from "../../utils/analytics";
import pageNames from "../../constants/pageNames";
import MultiplePetsContainer from "./multiplePets/multiplePetsContainer";
import closeIcon from "../../assets/images/icon-close-alert.png";
import DgdocUpload from "./DgBooking/dgdoc-upload";
import pdf from "../../assets/images/pdf.png";
import excel from "../../assets/images/excel.png";
import word from "../../assets/images/word.png";
import walpaper from "../../assets/images/walpaper.png";
import document from "../../assets/images/document.png";
import DgMultiUnidContainer from "./DgBooking/dgMultiUnidContainer";
import UldValidationPopupdg from "./DgBooking/UldValidationPopupdg";
import SearchPanelMessage from "./SearchPanelMessage";
import restrictedSeasonalSccs from "../../configs/restrictedSeasonalSccs";
import { getInitSeasonalFlightDetails, PREFERRED_SHIPMENT_TIME } from "../../constants";
import { getRestrictedList } from "../../services/quoteServices";
import sessionKeys from "../../constants/sessionKeys";
import RadioToggle from "./RadioToggle";
import { AlertMessage } from "./AlertMessage";
import { CustomPopup } from "../../common/Popup/CustomPopup";
import CommonInput from "../../common/Resusable/CommonInput";
import MutlipleBookingFlightSection from "./MutlipleBookingFlightSection";
import { getResumbitRequestBody } from "../PermanentBooking/PermanentBookingUtils";
import { useDispatch, useSelector } from "react-redux";
import { getCountryMaster, getRegionMaster } from "../../services/masterDataServices";
import { setMasterDataDetails } from "../../redux/actions/masterDataActions";
import { useLocation } from "react-router-dom";
import { CommonDropDown } from '../../common/Resusable/CommonDropDown';
import {
	default as SessionKeys,
} from "../../constants/sessionKeys";

const SearchPanel = ({
	searchFormData,
	setSearchFormDataToState,
	showErrorPopup,
	closeErrorPopup,
	getlistTemplateNamesResponse,
	listTemplateNamesResponse,
	getSaveTemplateResponse,
	saveTemplateResponse,
	awbNo,
	serialNo,
	templateParam,
	isModifyBooking,
	disableBeforeClosePrompt,
	validateBookingResponse,
	validateBookingError,
	validateBookingRequest,
	clearValidateBookingResponse,
	getSaveDraftResponse,
	saveDraftResponse,
	saveDraftError,
	getlistDraftsResponse,
	listDraftsResponse,
	clearSaveTemplateResponse,
	getlistQuoteResponse,
	listQuotesResponse,
	listQuoteError,
	clearSaveDraftResponse,
	setNotificationMessage,
	setNotificationType,
	listTemplateNamesError,
	listDraftsError,
	aviBookingDetaills,
	isSeasonalBooking,
	seasonalError,
	setSeasonalError,
	startDate,
	setStartDate,
	endDate,
	setEndDate,
	flightList,
	setFlightList,
	flightSelectedOrigin,
	setFlightSelectedOrigin,
	flightsMaxShippingDate,
	setFlightsMaxShippingDate,
	flightsMinDate,
	setFlightsMinDate,
	schedulerMaxShippingDate,
	setSchedulerMaxShippingDate,
	schedulerMinDate,
	setSchedulerMinDate,
	weekdays,
	setWeekdays,
	dateScheduler,
	setDateScheduler,
	isListPageOpen,
	setListPageOpen,
	setInitialList,
	clearToken,
	navigateBack,
	gsaAgentDetails,
	isMultipleBookingEdit,
}) => {
	const [unid, setUnid] = useState(null);
	const history = useHistory();
	const location = useLocation();
	const draftref = useRef(false);
	const { agentDetails } = gsaAgentDetails;

	const dispatch = useDispatch();

	const masterData = useSelector(state => state?.masterData);

	const [userDetails, setUserDetails] = useState(null);

	const [shippingItems, setShippingItems] = useState([]);

	const [services, setServices] = useState([]);

	const [recommendedServices, setRecommendedServices] = useState([]);

	const [selectedOrigin, setSelectedOrigin] = useState(
		searchFormData ? searchFormData.origin : null
	);

	const [defaultOrigin, setDefaultOrigin] = useState(null);
	const [isErrors, setIsErrors] = useState(false);

	const [selectedDestination, setSelectedDestination] = useState(
		searchFormData ? searchFormData.destination : null
	);

	const [documentRequired, setDocumentRequired] = useState({});

	const [isSearchByArrivalDate, setIsSearchByArrivalDate] = useState(
		searchFormData && searchFormData.arrivalDate ? true : false
	);

	const [shippingDate, setShippingDate] = useState(null);
	const [preferredShipmentTime, setPreferredShipmentTime] = useState(
		searchFormData && searchFormData.shippingTime ? searchFormData.shippingTime : null
	);

	const [arrivalDate, setArrivalDate] = useState(null);

	const [isUSBound, setIsUSBound] = useState(false);

	const [exceptionTypeDg, setExceptionTypeDg] = useState("");

	const [isUnknownShipment, setIsUnknownShipment] = useState(
		searchFormData && searchFormData.isUnknownShipment
			? searchFormData.isUnknownShipment
			: null
	);

	const [spUnid, setSpUnid] = useState();

	const [warning, setWarning] = useState(false);

	const [noanimals, setNoAnimals] = useState();

	const [maxShippingDate, setMaxShippingDate] = useState(
		moment()
			.add(ALLOWABLE_BOOKING_DATE - 1, "days")
			.toDate()
	);

	const [shippingItem, setShippingItem] = useState(
		searchFormData ? searchFormData.shippingItemCode : null
	);

	const [shipmentSccs, setShipmentSccs] = useState(
		searchFormData ? searchFormData.shipmentSccs || [] : []
	);
	const [appliedSccs, setAppliedSccs] = useState(
		searchFormData ? searchFormData.appliedSccs || [] : []
	);
	const [additionalSccs, setAdditionalSccs] = useState(
		searchFormData ? searchFormData.additionalSccs || [] : []
	);

	const [appliedServices, setAppliedServices] = useState(
		searchFormData ? searchFormData.appliedServices || [] : []
	);

	const [dgbookcheck, setDgbookcheck] = useState(
		searchFormData ? searchFormData.dgbookcheck : false
	);

	const [shippingType, setShippingType] = useState(
		searchFormData ? searchFormData.shippingType : SHIPPING_TYPE.LOOSE
	);

	const [isAllotmentRequired, setIsAllotmentRequired] = useState(true);
	const [isAllotmentRequiredFlightDate, setIsAllotmentRequiredFlightDate] =
		useState(true);
	const [indexArray, setIndexArray] = useState([]);

	//Units
	const [dimensionUnit, setDimensionUnit] = useState(
		searchFormData ? searchFormData.dimensionUnit : DIMENSION_UNIT.CENTIMETERS
	);
	const [weightUnit, setWeightUnit] = useState(
		searchFormData ? searchFormData?.weightUnit : WEIGHT_UNIT.KILOGRAM
	);

	//Loose Items Details Array
	const [looseItemsTotalWeight, setLooseItemsTotalWeight] = useState(
		searchFormData ? searchFormData?.totalWeight : null
	);

	//adjustedWeight
	const [adjustedWeight, setAdjustedWeight] = useState(
		searchFormData ? searchFormData?.adjustedWeight : null
	);

	const [looseItemsGrossWeight, setLooseItemsGrossWeight] = useState(0);
	const [calculatedTotalWeight, setCalculatedTotalWeight] = useState(0);
	const [showValidation, setshowValidation] = useState(false);
	const [looseDetails, setLooseDetails] = useState(
		searchFormData && searchFormData.looseDetails
			? searchFormData.looseDetails
			: [getInitLooseItemDetail()]
	);
	const [isAllStackable, setAllStackable] = useState(
		searchFormData ? searchFormData.isAllStackable || false : true
	);
	const [isAllTiltable, setAllTiltable] = useState(
		searchFormData ? searchFormData.isAllTiltable || false : false
	);

	const [sccWarning, setSccWarning] = useState(null);

	const [unidWarning, setUnidWarning] = useState(null);
	const [embargoErrorCheck, setEmbargoErrorCheck] = useState(true);
	const [specialProvisonErrorCheck, setSpecialProvisonErrorCheck] =
		useState(true);

	//ULD Items Details Array
	const [ULDDetails, setULDDetails] = useState(
		searchFormData && searchFormData.ULDDetails
			? searchFormData.ULDDetails
			: [getInitULDItemDetail()]
	);

	//Pharma Life && VAC specific state values...
	const [additionalInfoData, setAdditionalInfoData] = useState({
		type: null,
		pharma: {},
	});
	const [handlingInformation, setHandlingInformation] = useState(
		searchFormData && searchFormData.handlingInformation
			? searchFormData.handlingInformation
			: null
	);

	const [displayContainerPopup, setDisplayContainerPopup] = useState(false);
	const [displayShippingItemPopup, setDisplayShippingItemPopup] =
		useState(false);
	// const [displayDgULDItemPopup, setDisplayDgULDItemPopup] = useState(false)

	//Summary bucket state values
	const [actualVolume, setActualVolume] = useState(0);
	const [actualGrossWeight, setActualGrossWeight] = useState(0);
	const [actualTotalIneItemWeight, setActualTotalIneItemWeight] = useState(0);
	const [actualChargeableWeight, setActualChargeableWeight] = useState(0);

	const [grossWeightInSelectedUnit, setGrossWeightInSelectedUnit] = useState(0);
	const [grossWeightInConvertedUnit, setGrossWeightInConvertedUnit] =
		useState(0);
	const [densityInSelectedUnit, setDensityInSelectedUnit] = useState(0);
	const [densityInConvertedUnit, setdensityInConvertedUnit] = useState(0);
	const [chargeableWeightInSelectedUnit, setChargeableWeightInSelectedUnit] =
		useState(0);

	const [totalWeightInKg, setTotalWeightInKg] = useState(
		searchFormData ? searchFormData.totalWeightInKg : 0
	);
	const [totalPieces, setTotalPieces] = useState(
		searchFormData ? searchFormData?.totalPieces : 0
	);
	const [totalVolumeInMtrs, setTotalVolumeInMeters] = useState(
		searchFormData ? searchFormData.totalVolumeInMtrs : 0
	);
	const [chargeableWeight, setChargeableWeight] = useState(
		searchFormData ? searchFormData?.chargeableWeight : 0
	);

	const [cargoFlights, setCargoFlights] = useState(
		searchFormData ? searchFormData?.cargoFlightCheck : ""
	);

	const [sccCombinationError, setSccCombinationError] = useState("");

	const [sccCompatibilityError, setSccCompatibilityError] = useState("");

	const [sccCompatibility, setSccCompatibility] = useState("");

	const [error, setError] = useState(null);

	const [hasDangerous, setHasDangerous] = useState(false);

	const [hasDangerous1, setHasDangerous1] = useState(false);

	const [gradeoutQ, setGradeoutQ] = useState(false);

	const [priceCodeType, setPriceCodeType] = useState(
		PRICE_CODE_TYPE.PROMO_RATE
	);

	const [promoCode, setPromoCode] = useState("");

	const [spotRateCode, setSpotRateCode] = useState("");

	const [spotRateDetails, setSpotRateDetails] = useState(
		isModifyBooking && searchFormData && searchFormData.spotRateDetails
			? searchFormData.spotRateDetails
			: null
	);

	const [AviEnabled, setAviEnabled] = useState("false");
	const [dgarrayListDoc, setDgArrayListDoc] = useState(
		searchFormData && searchFormData?.dgAttachementDetails
			? [searchFormData?.dgAttachementDetails]
			: []
	);

	// const [dgarrayListDoc, setDgArrayListDoc] = useState([])
	const [arrayListDoc, setArrayListDoc] = useState([]);

	//Mix Booking
	const [mixLooseDetails, setMixLooseDetails] = useState(
		searchFormData && searchFormData.mixLooseDetails
			? searchFormData.mixLooseDetails
			: [getInitLooseItemDetail()]
	);
	const [expandAccordian, setExpandAccordian] = useState(
		searchFormData ? searchFormData.expandAccordian : false
	);

	const [footerErrorMsg, setFooterErrorMsg] = useState(null);

	const initShippingItem = useRef(
		searchFormData ? searchFormData.shippingItemCode : null
	);

	// onCommodity Change attachmentId change

	const [onCommodityChange, setOnCommodityChange] = useState(false);

	//Save template
	const [templateModal, setTemplateModal] = useState(false);
	const [templateName, setTemplateName] = useState("");
	const [serialNumber, setSerialNumber] = useState(null);
	const [selectedTemplate, setSelectedTemplate] = useState("");

	//save draft
	const [notLeave, setNotLeave] = useState(draftref?.current);
	const [draftName, setDraftName] = useState(`Draft`);
	const [locationListened, setLocationListened] = useState("");
	const [forInternalNav, setForInternalNav] = useState(false);

	const [initialLoading, setInitialLoading] = useState(false);
	//for multilingual
	const { t, i18n } = useTranslation(["labels", "errors"]);

	const [showOpWeight, setShowOpweight] = useState(
		searchFormData ? searchFormData.showOpWeight : false
	);

	const [sccCodeEntered, setSccCodeEntered] = useState("");
	const [animalNo, setAnimalNo] = useState();
	const [cageList, setCageList] = useState(
		searchFormData && searchFormData.crates
			? [...searchFormData.crates]
			: [getInitCageDetails(weightUnit, dimensionUnit)]
	);

	const setCageLists = (cageListNew) => {
		setCageList(cageListNew);
		setToSessionStorage("cageList", JSON.stringify(cageListNew));
	};
	const [breedRejected, setBreedRejected] = useState(false);

	const [petsAttachmentList, setPetAttachmentList] = useState([]);

	const [unidList, setUnidList] = useState(
		searchFormData && searchFormData.unid
			? [...searchFormData.unid]
			: [getInitUnidDetail()]
	);

	const [unidSccList, setUnidSccList] = useState([]);
	const [file, setFile] = useState([]);
	const [aviBookingError, setAviBookingError] = useState(false);
	const [dgBookingError, setDgBookingError] = useState(false);
	const [dgdocUpload, setDgdocUpload] = useState(false);
	const [dogBreeds, setDogBreeds] = useState([]);

	const [displayInfo, setDisplayInfo] = useState(
		aviBookingError ? true : false
	);
	const [displayDglist, setDisplayDglist] = useState(false);
	const [stubNose, setStubNose] = useState(false);

	const [unidName, setUnidName] = useState();
	const [errorMsgUnid, setErrorMsgUnid] = useState(false);

	const [dgEnabled, setDgEnabled] = useState(false);
	const [bookingRestrictionError, setBookingRestrictionError] = useState(false);
	const [bookingRestrictionType, setBookingRestrictionType] = useState(null);

	const [restrictionList, setRestrictionList] = useState([]);
	const [errorMessage, setErrorMessage] = useState("");
	const [isShippingFocused, setIsShippingFocused] = useState(false);
	const [flightDetailsData, setFlightDetailsData] = useState(null);
	const [flightDetailsError, setFlightDetailsError] = useState(new Map());
	const [sccInputChanged, setSccInputChanged] = useState(false);
	const [isBupSccPresent, setIsBupSccPresent] = useState(false);
	const [shippingTypeError, setShippingTypeError] = useState('');

	const timeOptions = [
		{ label: null, value: null },
		...PREFERRED_SHIPMENT_TIME.map(time => ({
			label: `${t('CHOOSE_FLT.FROM')} ${time.label} ${t('COMMON.HOURS_TEXT')}`,
			value: time.value
		}))
	];

	const [sccMaster, setSccMaster] = useState([]);
	const isCopyFlow = !!(searchFormData?.isCopyFlow || location.state?.isCopyFlow);

	useEffect(() => {
		const fetchSccMaster = async () => {
			try {
				// const sccMasterData = await getSccMaster();
				// setSccMaster(sccMasterData.scc || []);
				let sccMasterList;


				if (masterData?.sccListMaster && masterData.sccListMaster.length > 0) {

					sccMasterList = masterData.sccListMaster;
				} else {

					const sccMasterData = await getSccMaster();
					sccMasterList = sccMasterData.scc || [];
					if (sccMasterList && sccMasterList.length > 0) {
						const masterDataPayload = {
							...masterData,
							sccListMaster: sccMasterList,

						};
						dispatch(setMasterDataDetails(masterDataPayload));
					}
				}

				setSccMaster(sccMasterList || []);
			} catch (error) {
				console.error('Failed to fetch SCC master data:', error);
			}
		};
		fetchSccMaster();
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		if (searchFormData?.multipleBookingFlightData?.length !== 0) {
			setFlightDetailsData(searchFormData?.multipleBookingFlightData);
		} else {
			setFlightDetailsData([
				{
					origin: null,
					destination: null,
					flightDate: null,
					allotmentId: null,
					flightNumber: null,
				},
			]);
		}
	}, [searchFormData?.multipleBookingFlightData]);

	const listDgArray = [...file];

	useEffect(() => {
		listDgArray?.map((element) => {
			setDgArrayListDoc([...dgarrayListDoc, element]);
		});
	}, [file]);

	useEffect(() => {
		if (dgbookcheck) {
			setDgEnabled(true);
		} else {
			setDgEnabled(false);
		}
	}, [dgbookcheck]);

	useEffect(() => {
		if (footerErrorMsg) {
			setTimeout(function () {
				setFooterErrorMsg("");
			}, 5000);
		}
	}, [footerErrorMsg]);

	useEffect(() => {
		// window.scrollTo(0, 0);
		if (
			(!masterData?.regionMaster || masterData.regionMaster.length === 0) ||
			(!masterData?.countryMaster || masterData.countryMaster.length === 0)
		) {
			(async () => {
				try {
					const [regionRes, countryRes] = await Promise.all([
						getRegionMaster(),
						getCountryMaster()
					]);
					const regionMaster = regionRes?.length !== 0 ? regionRes : [];
					const countryMaster = countryRes?.length !== 0 ? countryRes : [];
					const masterData = { regionMaster, countryMaster }
					dispatch(setMasterDataDetails(masterData));
				} catch (error) {
					console.error('Master data fetch failed:', error);
				}
			})();
		}
	}, []);

	useEffect(() => {
		if (selectedOrigin) {
			const airportMaster = [selectedOrigin];
			dispatch(setMasterDataDetails({ airportMaster }))
		}

	}, [selectedOrigin])

	useEffect(() => {
		if (shippingItem) {
			var isNonStackable = looseDetails.some((stack) => !stack.stackable);
			if (isNonStackable) {
				let tempAppliedSccs = [...appliedSccs];
				const nscObj = {
					scc: "NST",
					sccDescription: "NON STACKABLE CARGO",
				};
				let isNscIncluded = tempAppliedSccs.some((item) => item.scc === "NST");
				if (
					!isNscIncluded &&
					shippingItem &&
					shippingItem.product !== "LiveAnimals"
				) {
					//Appending NST additional scc
					tempAppliedSccs.push(nscObj);
					setAppliedSccs(tempAppliedSccs);
				}
			}
			// Reset total pieces for LiveAnimals
			if (shippingItem?.product === "LiveAnimals") {
				setTotalPieces(0)
			}
		} else {
			setAppliedSccs([]);
		}
	}, [shippingItem]);

	const handelPopup = () => {
		setDisplayDglist(true);
	};
	const [displayUploadSection, setDisplayUploadSection] = useState(false);
	const [fileList, setFileList] = useState([]);
	const [fileName, setFileName] = useState("");

	const [specialProvison, setSpecialProvison] = useState();
	const [displayDgValidationPopup, setDisplayDgValidationPopup] =
		useState(false);
	const [displayDgULDItemPopup, setDisplayDgULDItemPopup] = useState(false);
	const [popupNotificationPopup, setPopupNotificationPopup] = useState({});
	const [deletedCageIds, setDeletedCageIds] = useState([]);
	const [deletedPetIds, setDeletedPetIds] = useState([]);

	const [unidArray, setUnidArray] = useState([]);

	const [dgSccCode, setDgSccCode] = useState(
		JSON.parse(getFromSessionStorage("dgsccCode"))
	);

	const [autoAdd, setAutoAdd] = useState(false);

	const specailProvialMessage = (e) => {
		if (e === "Yes") {
			setDisplayDgValidationPopup(true);
			setPopupNotificationPopup({
				header: "",
				body: t("COMMON.SP_VALID_MSG"),
			});
		} else {
			setDisplayDgValidationPopup(true);
			setPopupNotificationPopup({
				header: t("COMMON.SP_VALID_RESTRICTED"),
				body: t("COMMON.SP_VALID_RES_MSG"),
			});
		}
	};

	const handleRemovedg = (element, index) => {
		const data = {
			attachmentId: element.attachmentId,
			fileName: element.fileName,
		};
		setIsLoading(true);
		deletespecialcommodityattachment(data).then(async (res) => {
			try {
				if (res.status === "SUCCESS") {
					setIsLoading(false);
					//call toaster
					getToastSuccess("File Deleted");
					// myToast.current.show({ ...toastDetails, life: 4000 })
					const itemsTemp = dgarrayListDoc.filter((element, curr) => {
						return index !== curr;
					});
					const filesTemp = file.filter((item, curr) => {
						return item?.attachmentId !== element.attachmentId;
					})
					setDgArrayListDoc([...itemsTemp]);
					setFile([...filesTemp]);
				}
			} catch (error) {
				setIsLoading(false);
				setFile(null);
				getToastError("Failed to Delete");
			}
		});
	};

	const closeDialog = () => {
		setDisplayInfo(false);
		setAviBookingError(false);
		setDisplayDglist(false);
		setDgBookingError(false);
	};

	const customClose = (
		<i>
			<img src={closeIcon} alt="close" title="close" onClick={closeDialog} />
		</i>
	);

	useEffect(() => {
		// getUnidInfo().then((sccs) => {
		// 	if (sccs.length > 0) {
		// 		// setToSessionStorage('unidList', JSON.stringify(sccs))
		// 		setUnidArray(sccs);
		// 		setErrorMsgUnid(false);
		// 	} else {
		// 		setErrorMsgUnid(true);
		// 	}
		// });
		try {
			let unidList;
			if (masterData?.unidListMaster && masterData.unidListMaster.length > 0) {
				unidList = masterData.unidListMaster;
				setUnidArray(unidList);
				setErrorMsgUnid(false);
			} else {
				getUnidInfo().then((sccs) => {
					if (sccs && sccs.length > 0) {
						unidList = sccs;
						setUnidArray(unidList);
						setErrorMsgUnid(false);

						const masterDataPayload = {

							unidListMaster: unidList
						};
						dispatch(setMasterDataDetails(masterDataPayload));
					} else {
						setErrorMsgUnid(true);
					}
				});
			}
		} catch (error) {

			setErrorMsgUnid(true);
		}

		if (shippingItem?.code === "DOG" || shippingItem?.code === "CAT") {
			getAviBookingBreeds(shippingItem?.code).then((response) => {
				let breedsData = response;
				let otherOption = {
					breedCode: "Other",
					breedName: "Other",
				};
				breedsData.push(otherOption);
				setDogBreeds(breedsData);
				setAdjustedWeight(null);
				setShowOpweight(false);
			});
		}

		setDgbookcheck(false);
		setUnidName();
		setUnid();
		setUnidList([getInitUnidDetail()]);
		// setUnidSelectedValidation('')
		setAviBookingError(false);
		setDgBookingError(false);
		setFile([]);
		setExceptionTypeDg("");
		setDisplayDgValidationPopup(false);
		// setDisplayContainerPopup()
		//setDisplayShippingItemPopup(false)
		setStubNose(false);
		setDgArrayListDoc([]);
		setCageList([]);
		setToSessionStorage("ifDg", false);
		setHandlingInformation(null);
		// setOnCommodityChange(true)
	}, [shippingItem?.code]);

	useEffect(() => {
		let totalWeight = 0;
		let totalWeightinSelectedUnit = 0;
		if (cageList.length > 0) {
			[...cageList].map((item) => {
				totalWeight =
					totalWeight + Number(calculateWeightToKg(item.weight, weightUnit));
				totalWeightinSelectedUnit = totalWeightinSelectedUnit + item.weight;
			});
			if (shippingItem?.code === "DOG" || shippingItem?.code === "CAT") {
				setActualGrossWeight(totalWeightinSelectedUnit);

				setTotalWeightInKg(totalWeight);
			}
			setCageLists(cageList);
		}
		if (cageList.length > 0 && cageList[0]?.weight) {
			handleSummaryChange(cageList);
			let filteredDimensions = [...cageList].map((item) => {
				let items = {};
				items[LOOSE_ITEM_KEYS.LENGTH] = item.length;
				items[LOOSE_ITEM_KEYS.WIDTH] = item.width;
				items[LOOSE_ITEM_KEYS.HEIGHT] = item.height;
				items[LOOSE_ITEM_KEYS.PIECES] = 1;
				items[LOOSE_ITEM_KEYS.WEIGHT] = item.weight;
				items[LOOSE_ITEM_KEYS.TILTABLE] = "N";
				items[LOOSE_ITEM_KEYS.STACKABLE] = "N";
				(items[LOOSE_ITEM_KEYS.WEIGHT_UNIT] = WEIGHT_UNIT.KILOGRAM),
					(items[LOOSE_ITEM_KEYS.DIMENSION_UNIT] = "C");
				return items;
			});
			setLooseDetails(filteredDimensions);
		}
	}, [cageList]);

	const flatten = (arr) => {
		return arr.reduce(function (flat, toFlatten) {
			return flat.concat(
				Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten
			);
		}, []);
	};

	useEffect(() => {
		if (cageList?.length > 0 && cageList[0]?.weight) {
			let petAttachmentsArray = [];
			let snubNozedErrorArray = [];

			for (let i = 0; i < cageList.length; i++) {
				for (let j = 0; j < cageList[i].pets.length; j++) {
					//attachements
					petAttachmentsArray.push(cageList[i].pets[j].attachments);

					//snubNosed error check
					if (
						cageList[i].pets[j]?.error &&
						cageList[i].pets[j]?.error.snubNosed
					) {
						snubNozedErrorArray.push(cageList[i].pets[j].error.snubNosed);
					}
				}
			}
			//attachments
			let attachmentList = flatten(petAttachmentsArray);
			setPetAttachmentList(attachmentList);

			//snubNosed check
			let snubNozedErrorList = flatten(snubNozedErrorArray);
			if (snubNozedErrorList.length > 0) {
				setBreedRejected(true);
			} else {
				setBreedRejected(false);
			}
		}
	}, [cageList]);

	useEffect(() => {
		if (searchFormData) {
			if (
				searchFormData.sccCodes &&
				searchFormData.sccCodes.length &&
				searchFormData.sccCodes.some((e) => e.scc === "UKN")
			) {
				setIsUnknownShipment(true);
			} else if (searchFormData.isModifyBooking) {
				setIsUnknownShipment(false);
				// setUnid
			}

			//appending NST scc in edit
			setTimeout(() => {
				setHandlingInformation(searchFormData.handlingInformation);
				// var isNonStackable = searchFormData.sccCodes.some(
				// 	(sccCode) => sccCode.scc === "NST"
				// );
				const sccCodesArray = Array.isArray(searchFormData?.sccCodes) ? searchFormData.sccCodes : [];
				const isNonStackable = sccCodesArray.some((sccCode) => sccCode?.scc === "NST");
				if (isNonStackable) {
					let tempAppliedSccs = [...appliedSccs];
					const nscObj = {
						scc: "NST",
						sccDescription: "NON STACKABLE CARGO",
					};
					let isNscIncluded = tempAppliedSccs.some(
						(item) => item.scc === "NST"
					);
					if (
						!isNscIncluded &&
						searchFormData.shippingItemCode &&
						searchFormData.shippingItemCode?.product !== "LiveAnimals"
					) {
						//Appending NST additional scc
						tempAppliedSccs.push(nscObj);
						setAppliedSccs(tempAppliedSccs);
					}
				}
			}, 500);
		}

		setSpecialProvison();
	}, [searchFormData]);

	useEffect(() => {
		if (searchFormData?.crates?.length > 0) {
			let data = [...searchFormData.crates];
			setCageLists(data);
		}
	}, [searchFormData]);

	const setDropDownFileList = (list) => {
		setFileList(list);
	};

	const shippingTypesSelectItems = [
		{ label: t("COMMON.LOOSE"), value: SHIPPING_TYPE.LOOSE },
		{ label: t("COMMON.ULD"), value: SHIPPING_TYPE.ULD },
	];

	const unkownShipperSelectItems = [
		{ label: t("BOOKING.SHPR_KNOWN_BUTTON"), value: IS_KNOWN_UNKNOWN.KNOWN },
		{
			label: t("BOOKING.SHPR_UNKNOWN_BUTTON"),
			value: IS_KNOWN_UNKNOWN.UNKNOWN,
		},
	];

	const draftCallback = () => {
		draftref.current = true;
	};

	const handelDocRequired = (event) => {
		setDocumentRequired((prevState) => ({
			...prevState,
			[documentRequired.id]: true,
		}));
	};

	useEffect(() => {
		setNotLeave(draftref.current);
	}, [draftref?.current]);

	const onTabOkclick = (selectedCargoType) => {
		closeErrorPopup();
		setShippingType(selectedCargoType);
		if (selectedCargoType && selectedCargoType === "ULD") {
			if (
				dgSccCode?.includes(shippingItem.scc) ||
				(selectedCargoType === "ULD" && dgbookcheck)
			) {
				setDisplayDgULDItemPopup(true);
				setDgEnabled(true);
				setExceptionTypeDg("DG_ULD");
			}
			setAdjustedWeight(null);
			setShowOpweight(false);
		}
	};

	const onTabCancelclick = () => {
		closeErrorPopup();
	};
	const showTabPopup = (selectedCargoType) => {
		const header = t("COMMON.CONFIRM");
		const message =
			shippingType && SHIPPING_TYPE.LOOSE === shippingType
				? t(MESSAGES.BKG_TAB_MESSAGE_LOOSE, { ns: "errors" })
				: t(MESSAGES.BKG_TAB_MESSAGE_ULD, { ns: "errors" });
		const primaryBtnLbl = t("COMMON.OK");
		const acceptFn = () => {
			onTabOkclick(selectedCargoType);
		};
		const secondaryBtnLbl = t("COMMON.CANCEL");
		const rejectFn = () => {
			onTabCancelclick();
		};
		showErrorPopup(
			header,
			message,
			primaryBtnLbl,
			acceptFn,
			secondaryBtnLbl,
			rejectFn
		);
	};

	useEffect(() => {
		if (aviBookingDetaills?.length > 0) {
			setToSessionStorage(
				"dgsccCode",
				JSON.stringify(aviBookingDetaills[1]?.scccodes)
			);
		}

		if (
			shippingItem?.code === "DOG" ||
			shippingItem?.code === "CAT" ||
			dgSccCode?.includes(shippingItem?.scc) ||
			(!dgSccCode?.includes(shippingItem?.scc) && dgBookingError)
		) {

			if (dgSccCode?.includes(shippingItem?.scc)) {
				setHasDangerous1(true);
			}
			if (aviBookingDetaills?.length > 0) {
				let aviBookingMinDate = moment()
					.add(aviBookingDetaills[0].minBookingDays, "days")
					.toDate();
				let dgBookingMinDate = moment()
					.add(aviBookingDetaills[1].minBookingDays, "days")
					.toDate();
				if (
					moment(shippingDate) < moment(aviBookingMinDate) ||
					(moment(shippingDate) < moment(dgBookingMinDate) &&
						shippingItem !== null)
				) {
					if (shippingItem?.code === "DOG" || shippingItem?.code === "CAT") {
						setAviBookingError(true);
						setDgBookingError(false);
					} else if (
						dgSccCode?.includes(shippingItem?.scc) ||
						(!dgSccCode?.includes(shippingItem?.scc) && dgBookingError)
					) {
						setDgBookingError(true);
						setAviBookingError(false);
					}
					// setShippingDate(null)
				} else {
					setAviBookingError(false);
					setDgBookingError(false);
				}
			}
			setShippingType("LOOSE");
		} else {
			setHasDangerous1(false);
			setAviBookingError(false);
			setDgBookingError(false);
			// setDisplayShippingItemPopup(false)
			setExceptionTypeDg();
			setDisplayDgULDItemPopup(false);
			setDgEnabled(false);
			//setShippingType('LOOSE')
		}
		// setUnidList([getInitUnidDetail()]);
	}, [shippingDate, shippingItem]);

	useEffect(() => {
		if (saveDraftResponse?.bookingDraft?.draftName) {
			const encodedDraftSearchObject =
				getFromSessionStorage("savedDraftObject");
			if (encodedDraftSearchObject) {
				if (
					saveDraftResponse.draftNameDuplicate === false &&
					encodedDraftSearchObject != null
				) {
					handleDraftValueCallback();
				} else {
					setNotLeave(true);
				}
			} else {
				return;
			}
		} else {
			return;
		}
	}, [saveDraftResponse]);

	useEffect(() => {
		if (unidList.length > 0) {
			[...unidList].map((item) => {
				setUnid(item.unid);
			});
		}
	}, [unidList]);

	useEffect(() => {
		if (aviBookingDetaills?.length > 0) {
			// const dgSccCode = JSON.parse(getFromSessionStorage('dgsccCode'))
			// console.log("DGsccCode", dgSccCode, additionalSccs)
			const isDgsccInclude = dgSccCode?.some(
				(r) => additionalSccs?.scc?.indexOf(r) >= 0
			);
			const dgCheck = additionalSccs?.some((e) => dgSccCode?.includes(e.scc));
			if (dgCheck) {
				setDgbookcheck(true);
				setGradeoutQ(true);
			} else {
				if (
					searchFormData?.dgbookcheck &&
					shippingItem !== null &&
					dgbookcheck
				) {
					setDgbookcheck(true);
				}
				// else if (additionalSccs?.length > 0) {
				// 	setDgbookcheck(true)
				// }
				else {
					setDgbookcheck(false);
				}
				setGradeoutQ(false);
				if (unidList[0]?.unid) {
					setDgbookcheck(true);
				}
			}
		}
	}, [additionalSccs]);

	useEffect(() => {
		const fetchRestrictData = async () => {
			try {
				const activeLanguage = getFromLocalStorage(sessionKeys.I18NEST_LNG);
				const data = {
					restrictionTypes: ["ORG", "DEST"],
					lang: activeLanguage,
				};
				const response = await getRestrictedList(data);
				setRestrictionList(response);
			} catch (error) {
				console.error("Failed to fetch restriction list", error);
			}
		};

		// Fetch the restriction data
		fetchRestrictData();
	}, []);

	useEffect(() => {
		if (
			UNKNOWN_SHIPPER_ENABLED &&
			selectedOrigin?.countryCode === "US" &&
			selectedDestination &&
			selectedDestination?.countryCode !== "US"
		) {
			setIsUSBound(true);
		} else {
			setIsUSBound(false);
			setIsUnknownShipment(null);
		}
		if (aviBookingDetaills?.length > 0 && selectedOrigin !== null) {
			setToSessionStorage(
				"dgsccCode",
				JSON.stringify(aviBookingDetaills[1]?.scccodes)
			);
			const dgSccCode = JSON.parse(getFromSessionStorage("dgsccCode"));
			setDgSccCode(dgSccCode);
		}
		// Restricting the orgin and destination based on booking-restriction and Show Popup
		const checkRestrictions = async () => {
			let isRestricted = false;
			let restrictionMsg = "";

			const getRestrictionData = (restriction, selectedOriginOrDestination) => {
				const restrictedAirport = restriction?.airports?.find(
					(airport) =>
						airport.locationCode?.trim() === selectedOriginOrDestination?.code
				);
				if (restrictedAirport) {
					isRestricted = true;
					restrictionMsg = restrictedAirport.message;
				} else {
					const restrictedCountry = restriction?.countries?.find(
						(country) =>
							country.locationCode?.trim() ===
							selectedOriginOrDestination?.countryCode
					);
					if (restrictedCountry) {
						isRestricted = true;
						restrictionMsg = restrictedCountry.message;
					}
				}
			};

			restrictionList.forEach((restriction) => {
				switch (restriction.restrictionType) {
					// case "ORG":
					// 	getRestrictionData(restriction, selectedOrigin);
					// 	break;
					case "DEST":
						getRestrictionData(restriction, selectedDestination);
						break;
					default:
						break;
				}
			});

			// If a restriction is found, set the error message and trigger the popup
			if (isRestricted) {
				setErrorMessage(restrictionMsg);
				setBookingRestrictionError(true);
			} else {
				setBookingRestrictionError(false);
				setBookingRestrictionType(null);
			}
		};

		// Run the restriction check after fetching the restriction list
		checkRestrictions();
	}, [selectedOrigin, selectedDestination, restrictionList]);

	useEffect(() => {
		setBookingRestrictionType("ORG");
	}, [selectedOrigin]);

	useEffect(() => {
		setBookingRestrictionType("DEST");
	}, [selectedDestination]);

	const onCloseRussianResPopup = () => {
		if (bookingRestrictionType === "DEST") {
			setSelectedDestination(null);
		} else if (bookingRestrictionType === "ORG") {
			setSelectedOrigin(null);
		}
		setBookingRestrictionError(false);
		setBookingRestrictionType(null);
	};

	const checkChanges = (selectedCargoType) => {
		let findChanges = 0;
		if (selectedCargoType) {
			if (selectedCargoType === SHIPPING_TYPE.ULD) {
				looseDetails.some((item) => {
					Object.keys(item).some(function (k) {
						if (item[k] && k === "pieces") {
							showTabPopup(selectedCargoType);
							findChanges++;
						}
					});
				});
			} else {
				ULDDetails.some((item) => {
					Object.keys(item).some(function (k) {
						if (item[k] && k === "pieces") {
							showTabPopup(selectedCargoType);
							findChanges++;
						}
					});
				});
				mixLooseDetails.some((item) => {
					Object.keys(item).some(function (k) {
						if (item[k] && k === "pieces") {
							showTabPopup(selectedCargoType);
							findChanges++;
						}
					});
				});
			}
		}
		if (findChanges > 0) {
			return true;
		} else {
			if (selectedCargoType && selectedCargoType === "ULD") {
				if (
					dgSccCode?.includes(shippingItem?.scc) ||
					(selectedCargoType === "ULD" && dgbookcheck)
				) {
					setDisplayDgULDItemPopup(true);
					setDgEnabled(true);
					setExceptionTypeDg("DG_ULD");
				}
				setAdjustedWeight(null);
				setShowOpweight(false);
			}
			return false;
		}
	};

	useEffect(() => {
		if (arrivalDate) {
			const maxShippingDate = getMaxShippingDate(arrivalDate);
			setMaxShippingDate(maxShippingDate);
		} else {
			setMaxShippingDate(
				moment()
					.add(ALLOWABLE_BOOKING_DATE - 1, "days")
					.toDate()
			);
		}
	}, [arrivalDate]);

	useEffect(() => {
		if (!searchFormData) return;
		setSelectedOrigin(searchFormData.origin);
		setSelectedDestination(searchFormData.destination);

		if (searchFormData.orginalShipingDate instanceof Date) {
			setShippingDate(searchFormData.orginalShipingDate);
		} else if (typeof searchFormData.orginalShipingDate === "string") {
			const shippingDateObj = new Date(searchFormData.orginalShipingDate);
			setShippingDate(
				isNaN(shippingDateObj.getTime()) ? null : shippingDateObj
			);
		} else {
			setShippingDate(null);
		}
		if (searchFormData.shippingTime) {
			setPreferredShipmentTime(searchFormData.shippingTime);
		}

		if (searchFormData.arrivalDate instanceof Date) {
			setArrivalDate(searchFormData.arrivalDate);
		} else if (typeof searchFormData.arrivalDate === "string") {
			const arrivalDateObj = new Date(searchFormData.arrivalDate);
			setArrivalDate(isNaN(arrivalDateObj.getTime()) ? null : arrivalDateObj);
		} else {
			setArrivalDate(null);
		}

		setShippingItem(searchFormData.shippingItemCode);
		setShipmentSccs(
			searchFormData.shipmentSccs ? searchFormData.shipmentSccs : []
		);
		const appliedSccs =
			searchFormData.appliedSccs && searchFormData.appliedSccs.length
				? searchFormData.isModifyBooking
					? searchFormData.appliedSccs
					: searchFormData.appliedSccs.filter(
						(e) => !SYSTEM_ADDED_SCCS.includes(e.scc)
					)
				: [];
		if (isCopyFlow) {
			const masterList = Array.isArray(sccMaster) ? sccMaster : [];
			// original intersection with master
			const baseFilteredApplied = appliedSccs.filter(a =>
				masterList.some(m => m?.scc === a?.scc)
			);
			// restrict to those whose master entry has additionalScc === 'Y'
			const eligibleMaster = masterList.filter(m => m?.additionalScc === 'Y');
			const finalFilteredApplied = eligibleMaster.length
				? baseFilteredApplied.filter(a =>
					eligibleMaster.some(m => m?.scc === a?.scc)
				)
				: baseFilteredApplied;
			setAppliedSccs(finalFilteredApplied);
		} else {
			setAppliedSccs(appliedSccs);
		}
		// setAppliedSccs(appliedSccs);
		setAdditionalSccs(
			searchFormData.additionalSccs ? searchFormData.additionalSccs : []
		);
		setAppliedServices(searchFormData.appliedServices);
		setShippingType(searchFormData.shippingType);
		setDimensionUnit(searchFormData.dimensionUnit);
		setWeightUnit(searchFormData.weightUnit);
		setLooseItemsTotalWeight(searchFormData.totalWeight);
		setAdjustedWeight(searchFormData.adjustedWeight);
		setLooseDetails(
			searchFormData.looseDetails
				? searchFormData.looseDetails
				: [getInitLooseItemDetail()]
		);
		setAllStackable(searchFormData.isAllStackable);
		setAllTiltable(searchFormData.isAllTiltable);
		setULDDetails(
			searchFormData.ULDDetails
				? searchFormData.ULDDetails
				: [getInitULDItemDetail()]
		);
		setMixLooseDetails(
			searchFormData.mixLooseDetails
				? searchFormData.mixLooseDetails
				: [getInitLooseItemDetail()]
		);
		setPromoCode(searchFormData.promoCode ? searchFormData.promoCode : "");
		setSpotRateDetails(
			isModifyBooking && searchFormData && searchFormData.spotRateDetails
				? searchFormData.spotRateDetails
				: null
		);
		if (searchFormData.spotRateCode) {
			setPriceCodeType(PRICE_CODE_TYPE.SPOT_RATE);
			setSpotRateCode(searchFormData.spotRateCode);
		}

		const encodedSearchObject = getFromSessionStorage(SessionKeys.SEARCH_FORM_DATA_BOOKING);

		if (encodedSearchObject) {
			const searchObject = getBase64Decoded(encodedSearchObject);
			if (
				searchFormData.isUSBound &&
				(searchObject.isUnknownShipment || !searchObject.isUnknownShipment)
			) {
				setIsUnknownShipment(searchObject.isUnknownShipment);
			}
		}
		if (searchFormData?.dgbookcheck === true && searchFormData?.unid) {
			setDgbookcheck(true);
		}
	}, [searchFormData]);

	useEffect(() => {
		var isNonStackable = looseDetails.some((stack) => !stack.stackable);
		if (isNonStackable) {
			let tempAppliedSccs = [...appliedSccs];
			const nscObj = {
				scc: "NST",
				sccDescription: "NON STACKABLE CARGO",
			};
			let isNscIncluded = tempAppliedSccs.some((item) => item.scc === "NST");
			if (
				!isNscIncluded &&
				shippingItem &&
				shippingItem.product !== "LiveAnimals"
			) {
				//Appending NST additional scc
				tempAppliedSccs.push(nscObj);
				setAppliedSccs(tempAppliedSccs);
			}
		} else {
			let tempAppliedSccs = [...appliedSccs];
			let isNscIncluded = tempAppliedSccs.some((item) => item.scc === "NST");
			if (isNscIncluded) {
				let filteredSccs = tempAppliedSccs.filter((item) => item.scc !== "NST");
				setAppliedSccs([...filteredSccs]);
			}
		}
	}, [looseDetails]);

	useEffect(() => {
		var isNonStackable = mixLooseDetails.some((stack) => !stack.stackable);
		if (isNonStackable) {
			let tempAppliedSccs = [...appliedSccs];
			const nscObj = {
				scc: "NST",
				sccDescription: "NON STACKABLE CARGO",
			};
			let isNscIncluded = tempAppliedSccs.some((item) => item.scc === "NST");
			if (
				!isNscIncluded &&
				shippingItem &&
				shippingItem.product !== "LiveAnimals"
			) {
				//Appending NST additional scc
				tempAppliedSccs.push(nscObj);
				setAppliedSccs(tempAppliedSccs);
			}
		} else {
			let tempAppliedSccs = [...appliedSccs];
			let isNscIncluded = tempAppliedSccs.some((item) => item.scc === "NST");
			if (isNscIncluded) {
				let filteredSccs = tempAppliedSccs.filter((item) => item.scc !== "NST");
				setAppliedSccs([...filteredSccs]);
			}
		}
	}, [mixLooseDetails]);

	const getQuotes = () => {
		if (userDetails && !updateTemplateView && !isModifyBooking) {
			const listQuoteRequest = {
				requestID: uuidv4(),
				agentCode: userDetails.agentCode ? userDetails.agentCode : null,
			};
			getlistQuoteResponse(listQuoteRequest);
		}
	};

	useEffect(() => {
		const userDetails = getCurrentUser();
		setUserDetails(userDetails);
		clearItemFromSessionStorage("awbNumber");
		clearItemFromSessionStorage("flightSelected");
		clearItemFromSessionStorage("bookingDetails");
		clearItemFromSessionStorage("draftSelected");
		clearItemFromSessionStorage("quotationDetails");
		clearItemFromSessionStorage("quotationId");
		clearItemFromSessionStorage("sortOption");
		clearItemFromSessionStorage("selectedfilter");
		clearItemFromSessionStorage("quoteName");
		clearItemFromSessionStorage("flightUpsellOffered");
		clearItemFromSessionStorage("spotRate");
		clearItemFromSessionStorage("allInRate");

		const encodedSearchObject = getFromSessionStorage(SessionKeys.SEARCH_FORM_DATA_BOOKING);
		const encodedFlightEnquiryObject =
			getFromSessionStorage("flightEnquiryObj");
		const upsellOffered = getFromSessionStorage("upsellOffered");
		if (encodedSearchObject && encodedSearchObject !== "null") {
			const searchObject = getBase64Decoded(encodedSearchObject);

			setIsUnknownShipment(searchObject.isUnknownShipment);
			if (
				(searchObject &&
					// searchObject.isModifyBooking &&
					// searchObject.isModifyBooking !== true) ||
					!searchObject.isModifyBooking) ||
				(isModifyBooking && checkIsBackButtonAction(history))
			) {
				// setSearchFormDataToState(null);
				// //setSearchFormDataToState(searchObject)
				// setTimeout(() => {
				// 	setSearchFormDataToState(searchObject);
				// }, 2000);
				setSearchFormDataToState(searchObject);
			} else if (searchObject.isModifyBooking) {
				setSearchFormDataToState(null);
			}
			setTimeout(() => {
				clearItemFromSessionStorage(SessionKeys.SEARCH_FORM_DATA_BOOKING);
				//	clearItemFromSessionStorage('upsellOffered')
			}, 2000);
		} else if (
			encodedFlightEnquiryObject &&
			encodedFlightEnquiryObject !== "null"
		) {
			const searchFlightEnquiryObject = getBase64Decoded(
				encodedFlightEnquiryObject
			);
			if (searchFlightEnquiryObject?.isModifyBooking !== true) {
				setSearchFormDataToState(searchFlightEnquiryObject);
			} else if (searchFlightEnquiryObject.isModifyBooking) {
				setSearchFormDataToState(null);
			}
			setTimeout(() => {
				clearItemFromSessionStorage("flightEnquiryObj");
				//	clearItemFromSessionStorage('upsellOffered')
			}, 1000);
		} else {
			handleClear();
			if (defaultOrigin) {
				setSelectedOrigin(defaultOrigin);
			} else {
				getDefaultOrigin();
			}
		}

		getTemplates();
		getQuotes();

		const encodedAdditionalObject = getFromSessionStorage("additionalFormData");
		if (encodedAdditionalObject && encodedAdditionalObject !== "null") {
			let additionalObj = getBase64Decoded(encodedAdditionalObject);
			setAdditionalInfoData(additionalObj);
			setTimeout(() => {
				setAdditionalInfoData({
					type: null,
					pharma: {},
				});
				setAdditionalInfoData(additionalObj);
				clearItemFromSessionStorage("additionalFormData");
			}, 2000);
		}
		const encodedPharmaData = getFromSessionStorage("pharmaFormData");
		const dummy = {
			duration: 0,
			aircraftClassification: "",
			stops: null,
		};
		setToSessionStorage("selectedfilter", getBase64Encoded(dummy));
		pushPageData(
			pageNames.NEW_BOOKING,
			PAGE_PRIMARY_CATEGORY.E_SERVICES,
			PAGE_SUB_CATEGORY1.BOOKING,
			BOOKING_PAGE_SUB_CATEGORY2.NEW_BOOKING
		);
	}, []);

	useEffect(() => {
		setFooterErrorMsg(null);
	}, [
		selectedOrigin,
		selectedDestination,
		shippingDate,
		shippingItem,
		additionalInfoData,
		unid,
		looseItemsTotalWeight,
		looseDetails,
		ULDDetails,
		mixLooseDetails,
		expandAccordian,
		embargoErrorCheck,
		flightList,
		weekdays,
	]);
	useEffect(() => {
		if (!searchFormData) {
			if (
				userDetails &&
				userDetails.preference &&
				userDetails.preference.weightUnit &&
				userDetails.preference.dimensionUnit
			) {
				setWeightUnit(userDetails.preference.weightUnit);
				setDimensionUnit(userDetails.preference.dimensionUnit);
			}
			getDefaultOrigin();
		}

		getTemplates();
		getQuotes();
		(async () => {
			try {
				// let shippingItems = await getShippingItems();
				let shippingItems;
				if (masterData?.shippingItemsMaster && masterData.shippingItemsMaster.length > 0) {
					shippingItems = [...masterData.shippingItemsMaster];
				} else {
					shippingItems = await getShippingItems();
					if (shippingItems && shippingItems.length > 0) {
						const masterDataPayload = {
							shippingItemsMaster: shippingItems,

						};
						dispatch(setMasterDataDetails(masterDataPayload));
					}
				}
				if (shippingItems) {
					shippingItems = shippingItems?.map((item) => ({
						...item,
						description:
							item.description
								?.toLowerCase()
								?.split(" ")
								?.map((word) => word?.charAt(0)?.toUpperCase() + word.slice(1))
								?.join(" ") || item.description,
					}));
					shippingItems = shippingItems.sort((a, b) => {
						if (a.description < b.description) {
							return -1;
						}
						if (a.description > b.description) {
							return 1;
						}
						return 0;
					});
				}
				if (isSeasonalBooking) {
					let restrictedSCCs = restrictedSeasonalSccs;
					let seasonalshippingItems = shippingItems.filter(
						(item) => !restrictedSCCs.includes(item.scc)
					);
					setShippingItems(seasonalshippingItems);
				} else {
					setShippingItems(shippingItems);
				}
			} catch (err) {
				setNotificationMessage(
					"Sorry, Shipping Details could not retrive now .Please try again later "
				);
				addError(
					"SHIPPING_ITEM_API_ERROR",
					"Sorry, Shipping Details could not retrive now .Please try again later"
				);
				setNotificationType(NOTIFICATION_MESSAGE_TYPE.ERROR);
			}
		})();
	}, [userDetails]);

	useEffect(() => {
		if (shippingDate) {
			error
				? setError({
					...error,
					[FORM_FIELDS.SHIPPING_DATE]: null,
				})
				: setError({
					[FORM_FIELDS.SHIPPING_DATE]: null,
				});
		}
	}, [shippingDate]);

	useEffect(() => {
		(async () => {
			try {
				// const response = await getServices();
				// const { services } = response;
				// setServices(services);
				let servicesList;
				if (masterData?.servicesMaster && masterData.servicesMaster.length > 0) {
					servicesList = masterData.servicesMaster;
				} else {

					const response = await getServices();
					servicesList = response?.services || [];
					if (servicesList && servicesList.length > 0) {
						const masterDataPayload = {
							servicesMaster: servicesList
						};
						dispatch(setMasterDataDetails(masterDataPayload));
					}
				}

				setServices(servicesList || []);
			} catch (err) {
				setNotificationMessage("Service error");
				setNotificationType(NOTIFICATION_MESSAGE_TYPE.ERROR);
			}
		})();
	}, []);

	useEffect(() => {
		setError({
			...error,
			[FORM_FIELDS.LOOSE_ITEMS]: [],
			[FORM_FIELDS.ULD_ITEMS]: [],
			[FORM_FIELDS.TOTAL_WEIGHT]: "",
		});
		setshowValidation(false);
	}, [shippingType]);

	useEffect(() => {
		let volumetricWeight = 0;
		let chargeableWeight;
		let chargeableWeightInSelectedUnit;
		if (totalVolumeInMtrs) {
			volumetricWeight = Number(totalVolumeInMtrs).toFixed(2) * 166.6667;
			chargeableWeight = getRoundedValue(Number(volumetricWeight));
			// setChargeableWeight(chargeableWeight)
			// setChargeableWeightInSelectedUnit(chargeableWeight)
		}

		//Calculate totalWeight before taking stage build

		if (volumetricWeight) {
			const adjustedWeightInKg = adjustedWeight
				? calculateWeightToKg(adjustedWeight, weightUnit)
				: null;
			if (Number(totalWeightInKg) >= Number(volumetricWeight)) {
				if (
					adjustedWeightInKg &&
					Number(totalWeightInKg) <= Number(adjustedWeightInKg)
				) {
					chargeableWeight = getRoundedValue(Number(adjustedWeight));
					chargeableWeightInSelectedUnit = getRoundedValue(
						Number(adjustedWeight)
					);
				} else {
					chargeableWeight = getRoundedValue(Number(totalWeightInKg));
					if (weightUnit == WEIGHT_UNIT.POUND) {
						chargeableWeight = getRoundedValueDecimal(
							Number(totalWeightInKg) * 2.2046
						);
					} else if (weightUnit == WEIGHT_UNIT.TON) {
						chargeableWeight = getRoundedValueDecimal(
							Number(totalWeightInKg) * 0.00110231
						);
					}
				}
			} else {
				if (
					adjustedWeightInKg &&
					Number(volumetricWeight) <= Number(adjustedWeightInKg)
				) {
					chargeableWeight = getRoundedValue(Number(adjustedWeight));
					chargeableWeightInSelectedUnit = getRoundedValue(
						Number(adjustedWeight)
					);
				} else {
					chargeableWeight = getRoundedValue(Number(volumetricWeight));
					if (weightUnit == WEIGHT_UNIT.POUND) {
						chargeableWeight = getRoundedValueDecimal(
							Number(volumetricWeight) * 2.2046
						);
					} else if (weightUnit == WEIGHT_UNIT.TON) {
						chargeableWeight = getRoundedValueDecimal(
							Number(volumetricWeight) * 0.00110231
						);
					}
				}
			}
			setChargeableWeight(chargeableWeight);
			setChargeableWeightInSelectedUnit(chargeableWeight);
		}
	}, [totalVolumeInMtrs, totalWeightInKg]);

	const getDefaultOrigin = () => {
		let defaultAirport =
			userDetails && userDetails.defaultAirportCode
				? userDetails.defaultAirportCode
				: userDetails?.stationCode;
		// If GSA User Agent, default value is agentStationCode
		if (agentDetails?.agentDefaultAirportCode) {
			defaultAirport = agentDetails && agentDetails.agentDefaultAirportCode ? agentDetails.agentDefaultAirportCode : agentDetails.agentStationCode;
		}
		if (userDetails && defaultAirport) {
			getAirportsByCode(defaultAirport)
				.then((origin) => {
					setDefaultOrigin(origin);
					if (
						!getFromSessionStorage("searchObject") &&
						!getFromSessionStorage("flightEnquiryObj")
					) {
						setSelectedOrigin(origin);
					}
				})
				.catch((error) => console.log(error));
		}
	};

	useEffect(() => {
		const defaultAirport = agentDetails?.agentDefaultAirportCode || agentDetails?.agentStationCode;
		if (defaultAirport) {
			getAirportsByCode(defaultAirport)
				.then((origin) => {
					setDefaultOrigin(origin);
					if (
						!getFromSessionStorage(SessionKeys.SEARCH_FORM_DATA_BOOKING) &&
						!getFromSessionStorage("flightEnquiryObj")
					) {
						setSelectedOrigin(origin);
					}
				})
				.catch((error) => console.log(error));
		}
	}, [agentDetails]);

	const handelAddCAOAuto = (unidScc) => {
		setShipmentSccs(unidScc || []);
	};

	const handleRemoveScc = (scc) => {
		if (additionalSccs.map((item) => item.scc).includes(scc.scc)) {
			setAdditionalSccs(additionalSccs.filter((item) => item.scc !== scc.scc));
		}
		if (appliedServices.map((item) => item.scc).includes(scc.scc)) {
			setAppliedServices(
				appliedServices.filter((item) => item.scc !== scc.scc)
			);
		}
	};

	const handleSummaryChange = (LooseDetails) => {
		let quantity = 0;
		let totalVolumeinMeters = 0;
		let actualVolumeInSelectedUnit = 0;
		LooseDetails?.forEach(function (element) {
			if (element.pieces) {
				quantity += element.pieces * 1;
			}
			if (element.pieces && element.length && element.width && element.height) {
				actualVolumeInSelectedUnit +=
					parseFloat(element.width * element.length * element.height) *
					parseInt(element.pieces);
			}
			if (element.pieces && element.length && element.width && element.height) {
				if (dimensionUnit == DIMENSION_UNIT.INCHES) {
					totalVolumeinMeters +=
						parseFloat(
							element.width *
							0.0254 *
							(element.length * 0.0254) *
							(element.height * 0.0254)
						) * parseInt(element.pieces);
				}
				if (dimensionUnit == DIMENSION_UNIT.CENTIMETERS) {
					totalVolumeinMeters +=
						parseFloat(
							element.width *
							0.01 *
							(element.length * 0.01) *
							(element.height * 0.01)
						) * parseInt(element.pieces);
				}
			}
		});
		if (totalVolumeinMeters && totalVolumeinMeters < 0.01) {
			totalVolumeinMeters = 0.01;
		}
		if (actualVolumeInSelectedUnit && actualVolumeInSelectedUnit < 0.01) {
			actualVolumeInSelectedUnit = 0.01;
		}

		setActualVolume(actualVolumeInSelectedUnit);

		setTotalVolumeInMeters(totalVolumeinMeters);
		setTotalPieces(quantity);
	};

	const showCombinationError = (pharmaType, selectedScc) => {
		let convertedPharmaType = convertToLowerCase(pharmaType);
		setSccCombinationError(
			t(MESSAGES.COMPATIBILITY_ERROR, {
				SCC1: selectedScc,
				SCC2: convertedPharmaType,
				ns: "errors",
			})
		);
		setTimeout(function () {
			setSccCombinationError("");
		}, 5000);
	};

	const showSccCompatibilityError = (errorMsg) => {
		setSccCompatibilityError(errorMsg);
		addError("SCC_COMPATIBILITY_ERROR", errorMsg);
		setTimeout(function () {
			setSccCompatibilityError("");
		}, 5000);
	};
	const showWarning = () => {
		setWarning(true);
		setTimeout(function () {
			setWarning(false);
		}, 5000);
	};
	const checkShippingTypeCombinationScc = (scc) => {
		let validCombination = true;
		if (
			additionalInfoData.pharma.shippingPharmaType ===
			PHARMA_SHIPPING_TYPE.PASSIVE
		) {
			if (
				scc === SCC_CODES.PIP ||
				scc === SCC_CODES.ACT ||
				scc === SCC_CODES.FRO
			) {
				validCombination = false;
			}
		}
		if (
			additionalInfoData.pharma.shippingPharmaType ===
			PHARMA_SHIPPING_TYPE.ACTIVE
		) {
			if (scc === SCC_CODES.PIP) {
				validCombination = false;
			}
		}

		if (
			additionalInfoData.pharma.shippingPharmaType ===
			PHARMA_SHIPPING_TYPE.HYBRID
		) {
			if (scc === SCC_CODES.ACT) {
				validCombination = false;
			}
		}
		return validCombination;
	};
	const checkDryIceCombinationScc = (scc) => {
		let validCombination = true;
		if (
			additionalInfoData.pharma.isDryIceAdded === "NO" &&
			scc === SCC_CODES.ICE
		) {
			validCombination = false;
		}
		return validCombination;
	};
	const checkTemperatureCombinationScc = (scc) => {
		let validCombination = true;
		let temperatureArray = [
			SCC_CODES.TMP1,
			SCC_CODES.TMP2,
			SCC_CODES.TMP3,
			SCC_CODES.FRO,
		];
		if (temperatureArray.includes(scc)) {
			temperatureArray.forEach(function (element) {
				if (
					scc !== element &&
					(additionalSccs.map((item) => item.scc).includes(element) ||
						appliedSccs.map((item) => item.scc).includes(element))
				) {
					validCombination = false;
				}
			});
		}
		return validCombination;
	};

	const handleSccCompatibilityCheck = async (sccList) => {
		try {
			const responseBody = await checkSccCompatibility(sccList);

			if (responseBody && !responseBody.compatible) {
				let message = responseBody.message;
				message = message.replace("ER023", t("ER023", { ns: "errors" }));
				showSccCompatibilityError(message);
			}
			return responseBody.compatible;
		} catch (error) {
			setNotificationMessage(
				"SCC comapatibility check error :" + error.message ? error.message : ""
			);
			addError(
				"SCC_COMPATIBILITY_API_ERROR",
				"SCC comapatibility check error :" + error.message ? error.message : ""
			);
			setNotificationType(NOTIFICATION_MESSAGE_TYPE.ERROR);
		}
	};

	// const handleAddAdditinalScc = async (scc) => {
	// 	let compatible;
	// 	const selectedSccList = [
	// 		...shipmentSccs,
	// 		...appliedSccs,
	// 		...additionalSccs,
	// 		...appliedServices,
	// 	].map((item) => item.scc);

	// 	if (!selectedSccList?.length && scc) {
	// 		setAdditionalSccs([...additionalSccs, scc]);
	// 	} else if (
	// 		selectedSccList?.length &&
	// 		!selectedSccList?.includes(scc?.scc)
	// 	) {
	// 		compatible = await handleSccCompatibilityCheck({
	// 			selectedItems: selectedSccList,
	// 			newItem: scc?.scc,
	// 		});

	// 		if (additionalInfoData.pharma.shippingPharmaType && compatible) {
	// 			if (
	// 				!checkShippingTypeCombinationScc(scc.scc) ||
	// 				!checkDryIceCombinationScc(scc.scc) ||
	// 				!checkTemperatureCombinationScc(scc.scc)
	// 			) {
	// 				showCombinationError(
	// 					additionalInfoData.pharma.shippingPharmaType,
	// 					scc.scc
	// 				);
	// 			} else {
	// 				setAdditionalSccs([...additionalSccs, scc]);
	// 				if (
	// 					scc.scc === SCC_CODES.ICE &&
	// 					additionalInfoData.pharma.tempratureRange
	// 				) {
	// 					setAdditionalInfoData({
	// 						...additionalInfoData,
	// 						pharma: { ...additionalInfoData.pharma, isDryIceAdded: "YES" },
	// 					});
	// 				}
	// 				if (
	// 					scc.scc === SCC_CODES.ACT &&
	// 					(shippingItem.product === FRESH_FORWARD_PRODUCT ||
	// 						shippingItem.product === PHARMA_PRODUCT)
	// 				) {
	// 					setAdditionalInfoData({
	// 						...additionalInfoData,
	// 						pharma: {
	// 							...additionalInfoData.pharma,
	// 							shippingPharmaType: PHARMA_SHIPPING_TYPE.ACTIVE,
	// 						},
	// 					});
	// 				}
	// 			}
	// 		} else if (compatible) {
	// 			setAdditionalSccs([...additionalSccs, scc]);
	// 		}
	// 		setSccWarning(null);
	// 	} else {
	// 		if (autoAdd) {
	// 			setSccWarning(null);
	// 		} else {
	// 			setSccWarning(t(MESSAGES.SELECTED, { ns: "errors" }));
	// 		}
	// 	}
	// };


	const handleAddAdditinalScc = async (scc) => {
		setSccInputChanged(true);
		let compatible;
		const selectedSccList = [
			...shipmentSccs,
			...appliedSccs,
			...additionalSccs,
			...appliedServices,
		].map((item) => item.scc);

		// Treat XPS (and future service SCCs) like Recommended services
		const serviceSccCodes = ['XPS'];
		if (scc && serviceSccCodes.includes(scc.scc)) {
			if (selectedSccList.includes(scc.scc)) {
				if (!autoAdd) setSccWarning(t(MESSAGES.SELECTED, { ns: "errors" }));
				showWarning();
				return;
			}

			const serviceCompatible = await handleSccCompatibilityCheck({
				selectedItems: selectedSccList,
				newItem: scc.scc,
			});
			if (serviceCompatible) {
				setAppliedServices([...appliedServices, scc]);
				setSccWarning(null);
				showWarning();
			}
			return;
		}
		// SCC codes that should trigger temperature auto-selection
		const tempSccCodes = ['COL', 'CRT', 'ERT'];
		// ...existing code continues unchanged...
		// if (
		//     additionalInfoData?.pharma?.tempratureRange === PHARMA_TEMP_RANGE.NA &&
		//     tempSccCodes.includes(scc.scc)
		// ) {
		//     setSccCombinationError('Cannot add temperature SCC when temperature range is "Not applicable".');
		//     setTimeout(() => setSccCombinationError(''), 3000);
		//     return;
		// }

		if (!selectedSccList?.length && scc) {
			setAdditionalSccs([...additionalSccs, scc]);
			// If SCC is temperature-related, also add to appliedSccs
			if (tempSccCodes.includes(scc.scc)) {
				setAppliedSccs([...appliedSccs, scc]);
			}
		} else if (
			selectedSccList?.length &&
			!selectedSccList?.includes(scc?.scc)
		) {
			compatible = await handleSccCompatibilityCheck({
				selectedItems: selectedSccList,
				newItem: scc?.scc,
			});

			if (additionalInfoData.pharma.shippingPharmaType && compatible) {
				if (
					!checkShippingTypeCombinationScc(scc.scc) ||
					!checkDryIceCombinationScc(scc.scc) ||
					!checkTemperatureCombinationScc(scc.scc)
				) {
					showCombinationError(
						additionalInfoData.pharma.shippingPharmaType,
						scc.scc
					);
				} else {
					setAdditionalSccs([...additionalSccs, scc]);
					// If SCC is temperature-related, also add to appliedSccs
					if (tempSccCodes.includes(scc.scc)) {
						setAppliedSccs([...appliedSccs, scc]);
					}
					if (
						scc.scc === SCC_CODES.ICE &&
						additionalInfoData.pharma.tempratureRange
					) {
						setAdditionalInfoData({
							...additionalInfoData,
							pharma: { ...additionalInfoData.pharma, isDryIceAdded: "YES" },
						});
					}
					if (
						scc.scc === SCC_CODES.ACT &&
						(shippingItem.product === FRESH_FORWARD_PRODUCT ||
							shippingItem.product === PHARMA_PRODUCT)
					) {
						setAdditionalInfoData({
							...additionalInfoData,
							pharma: {
								...additionalInfoData.pharma,
								shippingPharmaType: PHARMA_SHIPPING_TYPE.ACTIVE,
							},
						});
					}
				}
			} else if (compatible) {
				setAdditionalSccs([...additionalSccs, scc]);
				// If SCC is temperature-related, also add to appliedSccs
				if (tempSccCodes.includes(scc.scc)) {
					setAppliedSccs([...appliedSccs, scc]);
				}
			}
			setSccWarning(null);
		} else {
			if (autoAdd) {
				setSccWarning(null);
			} else {
				setSccWarning(t(MESSAGES.SELECTED, { ns: "errors" }));
			}
		}
	};

	const handleAppliedRecommendedScc = async (scc) => {
		let compatible;
		const selectedSccList = [
			...shipmentSccs,
			...appliedSccs,
			...additionalSccs,
			...appliedServices,
		].map((item) => item.scc);
		if (!selectedSccList.includes(scc.scc)) {
			compatible = await handleSccCompatibilityCheck({
				selectedItems: selectedSccList,
				newItem: scc.scc,
			});
			if (compatible) {
				setAppliedServices([...appliedServices, scc]);
			}
		}
	};

	const clearPharmaState = () => {
		setAdditionalInfoData({
			...additionalInfoData,
			type:
				shippingItem &&
					(shippingItem.product === FRESH_FORWARD_PRODUCT ||
						shippingItem.product === PHARMA_PRODUCT)
					? "pharma"
					: null,
			pharma: getInitPharmaObject(),
		});
	};

	useEffect(() => {
		if (
			(initShippingItem.current &&
				shippingItem &&
				initShippingItem.current.key === shippingItem.key) ||
			(shippingItem &&
				searchFormData &&
				searchFormData.sccCodesList &&
				searchFormData.sccCodesList.includes(shippingItem.scc))
		) {
			return;
		}
		initShippingItem.current = shippingItem;
		clearItemFromSessionStorage("upsellOffered");
		setRecommendedServices(recommendedServices);
		if (shippingItem && shippingItem.scc) {
			if (additionalSccs.map((item) => item.scc).includes(shippingItem.scc)) {
				let tempAdditionalScc = additionalSccs.filter(function (obj) {
					return obj.scc !== shippingItem.scc;
				});
				setAdditionalSccs([...tempAdditionalScc]);
			}
		}

		const selectedShipmentSccs =
			shippingItem && shippingItem.scc
				? [
					{
						scc: shippingItem.scc,
						sccDescription: shippingItem.sccDescription,
					},
				]
				: [];
		setShipmentSccs(selectedShipmentSccs || []);

		setAdditionalSccs([]);
		setAppliedSccs([]);
		setRecommendedServices([]);
		setAppliedServices([]);
		clearPharmaState();
		// setUnidList(searchFormData && searchFormData.unid
		// 	? [...searchFormData.unid]
		// 	:
		// 	[getInitUnidDetail()])

		setSccWarning(null);
		if (shippingItem && shippingItem?.code === "APHARMA") {
			setAdditionalInfoData({
				...additionalInfoData,
				type: "pharma",
				pharma: {
					...additionalInfoData?.pharma,
					shippingPharmaType: PHARMA_SHIPPING_TYPE.ACTIVE,
				},
			});
		}
		setCageLists([getInitCageDetails(weightUnit, dimensionUnit)]);
		if (shippingItem && shippingItem?.scc === "AVI") {
			setLooseDetails([getInitLooseItemDetail()]);
		}

		if (dgSccCode?.includes(shippingItem?.scc)) {
			setDisplayShippingItemPopup(false);
		}
		setDgbookcheck(false);
		setUnidList([getInitUnidDetail()]);
		setUnidName();
		setUnid();

		if (dgarrayListDoc.length <= 0) {
			setTimeout(async () => {
				await setSearchFormDataToState(null);
			}, 100);

			setOnCommodityChange(true);
		}

		// if (searchFormData?.dgbookcheck) {
		// 	setDgbookcheck(true)
		// 	setToSessionStorage('ifDg', true)

		// }
		// else {
		// 	setDgbookcheck(false)
		// 	setToSessionStorage('ifDg', false)
		// }
	}, [shippingItem]);

	useEffect(() => {
		if (
			[...(shipmentSccs || []), ...(appliedSccs || [])].length &&
			additionalSccs.length
		) {
			const tempAdditionalSccs = additionalSccs.filter(
				(scc) =>
					![...shipmentSccs, ...appliedSccs].map((e) => e.scc).includes(scc.scc)
			);
			setAdditionalSccs(tempAdditionalSccs);
		}
	}, [shipmentSccs, appliedSccs]);

	useEffect(() => {
		if ([...shipmentSccs, ...appliedSccs, ...additionalSccs].length) {
			const recommendedSccs = (
				shippingItem && shippingItem.serviceSelection
					? shippingItem.serviceSelection.split(",")
					: []
			).filter(
				(scc) =>
					![
						...shipmentSccs,
						...appliedSccs,
						...additionalSccs,
						...appliedServices,
					]
						.map((item) => item.scc)
						.includes(scc)
			);
			setRecommendedServices(recommendedSccs);
		}
		// if (cargoFlight) {
		// 	const caoAppend = {
		// 		"scc": "CAO",
		// 		"sccDescription": "CARGO AIRCRAFT ONLY"
		// 	}
		// 	setAdditionalSccs([...additionalSccs, caoAppend])
		// }
	}, [shipmentSccs, appliedSccs, additionalSccs, appliedServices]);

	useEffect(() => {
		const allSccs = [
			...(shipmentSccs || []),
			...(appliedSccs || []),
			...(additionalSccs || []),
			...(appliedServices || [])
		].map(item => item.scc);
		if (checkForBupLooseRestriction(allSccs)) {
			setIsBupSccPresent(true);
			setShippingType('ULD');
		} else {
			setIsBupSccPresent(false);
		}
	}, [shipmentSccs, appliedSccs, additionalSccs, appliedServices]);

	useEffect(() => {
		if (shippingItem && appliedServices && appliedServices.length) {
			const XPSService = appliedServices.find(
				(service) => service.scc === "XPS"
			);
			if (XPSService) {
				const service = services.find((el) => el.scc === XPSService.scc);
				if (service) {
					//setShippingItem({ ...shippingItem, serviceProduct: service.product })
					setShippingItem({
						...shippingItem,
						serviceProduct: shippingItem.product,
					});
				}
			} else {
				if (shippingItem.serviceProduct) {
					setShippingItem({ ...shippingItem, serviceProduct: null });
				}
			}
		} else {
			if (shippingItem && shippingItem.serviceProduct) {
				setShippingItem({ ...shippingItem, serviceProduct: null });
			}
		}
	}, [appliedServices]);

	const handleCancel = () => {
		setAviBookingError(false);
		setDgBookingError(false);
		setShippingDate(null);
	};

	const handleConfirm = async () => {
		setAviBookingError(false);
		setDgBookingError(false);
		setShippingDate(null);
	};

	const RenderFooter = ({ onConfirmClick }) => {
		return (
			<div>
				<button
					className="primary-button mt-1"
					onClick={onConfirmClick || handleConfirm}
				>
					{t("COMMON.OK")}
				</button>
				{/* <button className='button secondary' onClick={handleCancel}>
					{t('COMMON.CANCEL')}
				</button> */}
			</div>
		);
	};

	const clearError = (key) => {
		const tempError = error ? { ...error } : null;
		if (tempError) {
			tempError[key] = null;
			setError(tempError);
		}
	};

	const handleAddLineItem = (e) => {
		e.preventDefault();

		if (shippingType === SHIPPING_TYPE.LOOSE) {
			setLooseDetails([
				...looseDetails,
				handleTilteableAndStackable(
					getInitLooseItemDetail(),
					isAllTiltable,
					isAllStackable
				),
			]);
		} else {
			setULDDetails([...ULDDetails, getInitULDItemDetail()]);
		}
	};

	const handleAppliedAddScc = async (sccCode) => {
		let scc, compatible;
		scc = { scc: sccCode };
		const selectedSccList = [
			...shipmentSccs,
			...appliedSccs,
			...additionalSccs,
			...appliedServices,
		].map((item) => item.scc);

		if (!selectedSccList.includes(scc)) {
			compatible = await handleSccCompatibilityCheck({
				selectedItems: selectedSccList,
				newItem: sccCode,
			});
			if (compatible) {
				setSccCompatibility("true");
				setAppliedSccs([...appliedSccs, scc]);
			} else {
				setSccCompatibility("false");
			}
		}
	};

	// Helper function to check if shipment is big
	function checkIsBigShipment({ commodityCode, weight, dimensions }) {
		const bigSccs = ['ACE'];
		const bigWeight = 6000; // kg

		if (bigSccs.includes(commodityCode)) return true;

		if (dimensions) {
			for (const d of dimensions) {
				if (d.weight && d.numberOfPieces) {
					const weightPerItem = d.weight / d.numberOfPieces;
					if (weightPerItem > bigWeight) return true;
				}
			}
			if (
				weight &&
				dimensions.length === 1 &&
				dimensions[0].numberOfPieces === 1
			) {
				const weightPerItem = weight / dimensions[0].numberOfPieces;
				if (weightPerItem > bigWeight) return true;
			}
		}

		return false;
	}

	// Helper function to check if shipment is small
	function checkIsSmallShipment({ product, weight, dimensions }) {
		// Only these products are eligible for small shipment
		const allowedProducts = ['GeneralCargo']; // Add more if needed

		// Business rules from config
		const maxWeight = 45; // kg
		const maxDimension = 80; // cm
		const maxTotalDimension = 200; // cm

		// Product eligibility check
		if (!allowedProducts.includes(product)) {
			return false;
		}

		// There must be at least one dimension set
		if (!Array.isArray(dimensions) || dimensions.length === 0) {
			return false;
		}

		// Weight check
		if (typeof weight !== 'number' || weight > maxWeight) {
			return false;
		}

		// All dimension sets must pass
		for (const d of dimensions) {
			// Explicitly convert to number for robustness
			const len = Number(d.length);
			const wid = Number(d.width);
			const hei = Number(d.height);
			// Each dimension must be a positive number and ≤ maxDimension
			if (
				!Number.isFinite(len) || len <= 0 || len > maxDimension ||
				!Number.isFinite(wid) || wid <= 0 || wid > maxDimension ||
				!Number.isFinite(hei) || hei <= 0 || hei > maxDimension
			) {
				return false;
			}
			// Total dimension check
			const total = len + wid + hei;
			if (total > maxTotalDimension) {
				return false;
			}
		}

		// All checks passed
		return true;
	}



	const mapValidateBookingToSelectedFlight = (payload, awbFlightDetails, additionalFlightDetails) => {
		const vb = payload?.validateBookingDetails;
		const productName = vb?.shipmentDetails?.productDetails?.productName;
		const segments = vb?.bookingFlightDetails || [];
		if (!vb || !segments.length) return null;

		const firstSeg = segments[0];
		const lastSeg = segments[segments.length - 1];

		const origin = firstSeg.segmentOrigin;
		const destination = lastSeg.segmentDestination;
		const departureDateTime = firstSeg.segmentDepartureDate;
		const arrivalDateTime = lastSeg.segmentArrivalDate;

		// Helper function to find matching awbFlight for a segment
		const findMatchingAwbFlight = (segment) => {
			if (!awbFlightDetails || !awbFlightDetails.length || !segment) return null;
			return awbFlightDetails.find(awbFlight =>
				awbFlight.segmentOrigin === segment.segmentOrigin &&
				awbFlight.segmentDestination === segment.segmentDestination &&
				awbFlight.carrierCode === segment.carrierCode &&
				awbFlight.flightNumber === segment.flightNumber &&
				awbFlight.flightDate === segment.flightDate
			);
		};

		// Get enhanced flight details for the first segment (for overall journey data)
		const firstAwbFlight = findMatchingAwbFlight(firstSeg);

		// Compute journey time HH:mm safely using moment
		let cumulativeJourneyTime = null;
		let flyingHours = null;

		// Use flyingHours from awbFlightDetails if available, otherwise calculate
		if (firstAwbFlight && firstAwbFlight.flyingHours) {
			flyingHours = firstAwbFlight.flyingHours;
			cumulativeJourneyTime = firstAwbFlight.flyingHours;
		} else if (departureDateTime && arrivalDateTime) {
			const dep = moment(departureDateTime, 'DD-MMM-YYYY HH:mm:ss', true);
			const arr = moment(arrivalDateTime, 'DD-MMM-YYYY HH:mm:ss', true);
			// Fallback: try lenient parse if strict failed
			const depM = dep.isValid() ? dep : moment(departureDateTime);
			const arrM = arr.isValid() ? arr : moment(arrivalDateTime);
			if (depM.isValid() && arrM.isValid()) {
				const dur = moment.duration(arrM.diff(depM));
				const h = Math.max(0, Math.floor(dur.asHours()));
				const m = Math.max(0, dur.minutes());
				const pad = (n) => String(n).padStart(2, '0');
				cumulativeJourneyTime = `${pad(h)}:${pad(m)}`;
				flyingHours = cumulativeJourneyTime;
			}
		}

		const flightSegmentList = segments.map((seg, index) => {
			const matchingAwbFlight = findMatchingAwbFlight(seg);

			return {
				aircraftType: seg.aircraftType ?? matchingAwbFlight?.aircraftType,
				combinationId: seg.combinationId ?? matchingAwbFlight?.combinationId,
				combinationSerialNumber: seg.combinationSerialNumber ?? matchingAwbFlight?.combinationSerialNumber,
				connectionSerialNumber: seg.connectionSerialNumber ?? matchingAwbFlight?.connectionSerialNumber,
				arrivalDateTime: seg.segmentArrivalDate ?? matchingAwbFlight?.arrivalDateTime,
				departureDateTime: seg.segmentDepartureDate ?? matchingAwbFlight?.departureDateTime,
				directFlight: seg.directFlight ?? matchingAwbFlight?.directFlight,
				estimatedArrivalDateTime: seg.estimatedArrivalDateTime ?? matchingAwbFlight?.estimatedArrivalDateTime,
				estimatedDepartureDateTime: seg.estimatedDepartureDateTime ?? matchingAwbFlight?.estimatedDepartureDateTime,
				flightCarrierCode: seg.carrierCode ?? matchingAwbFlight?.flightCarrierCode,
				flightCarrierId: seg.flightCarrierId ?? matchingAwbFlight?.flightCarrierId,
				flightDate: seg.flightDate ?? matchingAwbFlight?.flightDate,
				flightNumber: seg.flightNumber ?? matchingAwbFlight?.flightNumber,
				flightSequenceNumber: seg.flightSequenceNumber ?? matchingAwbFlight?.flightSequenceNumber,
				flightType: seg.flightType ?? matchingAwbFlight?.flightType,
				route: seg.segmentOrigin && seg.segmentDestination ? `${seg.segmentOrigin}-${seg.segmentDestination}` : matchingAwbFlight?.route,
				segmentDestination: seg.segmentDestination ?? matchingAwbFlight?.segmentDestination,
				segmentOrigin: seg.segmentOrigin ?? matchingAwbFlight?.segmentOrigin,
				originCityName: seg.originCityName ?? matchingAwbFlight?.originCityName,
				destCityName: seg.destCityName ?? matchingAwbFlight?.destinationCityName,
				originAirportName: seg.originAirportName ?? matchingAwbFlight?.originAirportName,
				destAirportName: seg.destAirportName ?? matchingAwbFlight?.destinationAirportName,
				stops: seg.stops ?? matchingAwbFlight?.stops,
				cumulativeJourneyTime: seg.cumulativeJourneyTime ?? matchingAwbFlight?.flyingHours ?? cumulativeJourneyTime,
				flyingHours: seg.flyingHours ?? matchingAwbFlight?.flyingHours ?? flyingHours,
				layoverTime: seg.layoverTime ?? matchingAwbFlight?.layoverTime,
				charterFlight: seg.charterFlight ?? matchingAwbFlight?.charterFlight,
				aircraftClassification: seg.aircraftClassification ?? matchingAwbFlight?.aircraftClassification,
				flightStatus: seg.flightStatus ?? seg.flightBookingStatus ?? matchingAwbFlight?.flightStatus,
			};
		});

		const fallbackCurrency = vb?.shipmentDetails?.currency || null;
		const allInRate = vb?.allInRate === 'Y';

		// Normalize payload.ratingDetails to the expected structure
		const rateDetailsArr = Array.isArray(vb?.ratingDetails) ? vb.ratingDetails : [];
		const ratingDetails = (rateDetailsArr.length ? rateDetailsArr : [{}]).map((d) => {
			const rate = d?.rate != null ? Number(d.rate) : null;
			const freightCharge = d?.freightCharge != null ? Number(d.freightCharge) : 0;
			const totalOtherCharge = d?.totalOtherCharge != null ? Number(d.totalOtherCharge) : 0;
			const totalCharge = d?.totalCharge != null ? Number(d.totalCharge) : 0;
			const currency = d?.currency || fallbackCurrency;
			const otherChargeDetails = Array.isArray(d?.otherChargeDetails) ? d.otherChargeDetails : [];
			const rateClass = d?.rateClass ?? null;
			const netRate = d?.netRate != null ? Number(d.netRate) : null;

			// Map to expected structure for ratingDetails
			return {
				product: productName,
				currency,
				rateLineDetails: [],
				totalFreightCharge: freightCharge,
				totalFreightRate: rate || 0,
				spotRateInfo: null,
				quotationID: payload?.quotationID || null,
				quotationGeneratedDateTime: null,
				otherChargeDetails: otherChargeDetails.map(charge => ({
					paymentType: charge.paymentType || null,
					dueCarrierFlag: charge.dueAgent === false,
					dueAgentFlag: charge.dueAgent === true,
					otherChargeHeadCode: charge.code || charge.otherChargeHeadCode,
					otherChargeHeadName: charge.name || charge.otherChargeHeadName,
					otherChargeAmount: charge.amount || charge.otherChargeAmount
				})),
				totalSurcharge: totalOtherCharge,
				totalCharge: totalCharge,
				totalRate: rate || 0,
				totalAdditionalCharges: null,
				grandTotal: totalCharge,
				allInRate: allInRate
			};
		});

		// Calculate bigShipment and smallShipment using helper functions
		const bigShipment = checkIsBigShipment({
			commodityCode: vb?.shipmentDetails?.commodityCode,
			weight: vb?.shipmentDetails?.weight,
			dimensions: vb?.shipmentDetails?.dimensions,
		});
		const smallShipment = checkIsSmallShipment({
			product: vb?.shipmentDetails?.productDetails?.productName,
			weight: vb?.shipmentDetails?.weight,
			dimensions: vb?.shipmentDetails?.dimensions,
		});

		return {
			route: `${origin}-${destination}`,
			origin,
			destination,
			originCityName: firstAwbFlight?.originCityName || "",
			destCityName: firstAwbFlight?.destinationCityName || "",
			originAirportName: firstAwbFlight?.originAirportName || "",
			destAirportName: firstAwbFlight?.destinationAirportName || "",
			cumulativeJourneyTime,
			flyingHours,
			layoverTime: firstAwbFlight?.layoverTime || "",
			arrivalDateTime,
			departureDateTime,
			lastAcceptanceTime: additionalFlightDetails?.lastAcceptanceTime || null,
			earliestDeliveryTime: additionalFlightDetails?.earliestDeliveryTime || null,
			dropOffAddress: additionalFlightDetails?.dropOffAddress || null,
			pickUpAddress: additionalFlightDetails?.pickUpAddress || null,
			flightSegmentList,
			ratingDetails: ratingDetails?.length ? ratingDetails : null,
			isForceQueued: vb?.forceQueue || false,
			overBookingAllowed: vb?.overBookingAllowed || false,
			overHangShipment: vb?.overHangShipment || false,
			bigShipment,
			smallShipment,
			infoMessages: vb?.infoMessages || [],
			warningMessages: vb?.warningMessages || [],
			usoutbound: vb?.usoutbound || null,
			serviceApplicable: vb?.serviceApplicable || null,
			allotmentAvailable: vb?.allotmentAvailable || null,
			productNameForSummary: productName
		};
	};


	const initiateListFlightRequest = async (tempLooseDetails, type) => {
		const bookedFlightDetails = await getBookingFlightDetails(
			searchFormData,
			shippingDate
		);

		let allSccCodes = removeDuplicates([
			...shipmentSccs,
			...appliedSccs,
			...additionalSccs,
			...appliedServices,
		]);

		if (isUnknownShipment) {
			// If unknown shipment and UKN not present, add it
			if (!allSccCodes.some(sccData => sccData?.scc === 'UKN')) {
				allSccCodes.push({ scc: 'UKN' });
			}
		} else {
			// If known shipment, remove UKN if present
			allSccCodes = allSccCodes.filter(sccData => sccData?.scc !== 'UKN');
		}

		let formData = {
			origin: selectedOrigin,
			destination: selectedDestination,
			orginalShipingDate: shippingDate
				? moment(shippingDate, "DD-MMM-YYYY").format("DD-MMM-YYYY")
				: null,
			shippingDate: shippingDate
				? moment(shippingDate, "DD-MMM-YYYY").format("DD-MMM-YYYY")
				: null,
			shippingTime: preferredShipmentTime ? preferredShipmentTime : null,
			arrivalDate: arrivalDate
				? moment(arrivalDate, "DD-MMM-YYYY").format("DD-MMM-YYYY")
				: null,
			shippingItemCode: shippingItem,
			shippingType: shippingType,
			isUSBound,
			isUnknownShipment,
			weightUnit,
			dimensionUnit,
			shipmentSccs,
			appliedSccs,
			additionalSccs,
			appliedServices,
			sccCodes: allSccCodes,
			totalWeight: looseItemsTotalWeight ? looseItemsTotalWeight : null,
			adjustedWeight: adjustedWeight,
			totalVolumeInMtrs,
			totalWeightInKg,
			actualGrossWeight,
			calculatedTotalWeight,
			actualTotalIneItemWeight,
			actualVolume,
			actualChargeableWeight,
			totalPieces,
			looseDetails: tempLooseDetails ? tempLooseDetails : looseDetails,
			isAllStackable,
			isAllTiltable,
			ULDDetails,
			chargeableWeight,
			mixLooseDetails,
			expandAccordian,
			promoCode:
				priceCodeType === PRICE_CODE_TYPE.PROMO_RATE &&
					promoCode &&
					promoCode.length
					? promoCode
					: null,
			spotRateCode:
				priceCodeType === PRICE_CODE_TYPE.SPOT_RATE &&
					spotRateCode &&
					spotRateCode.length
					? spotRateCode
					: null,
			spotRateDetails:
				isModifyBooking && spotRateDetails ? spotRateDetails : null,
			grossWeightInSelectedUnit: grossWeightInSelectedUnit,
			//removeCommaFromNumber(grossWeightInSelectedUnit),
			grossWeightInConvertedUnit,
			densityInSelectedUnit,
			densityInConvertedUnit,
			chargeableWeightInSelectedUnit: chargeableWeightInSelectedUnit,
			additionalInfo: additionalInfoData,
			handlingInformation: handlingInformation,
			currency:
				searchFormData && searchFormData.currency
					? searchFormData.currency
					: "",
			bookingFlightDetails: bookedFlightDetails,
			isModifyBooking: isModifyBooking,
			awbNo: awbNo,
			showOpWeight,
			unid: unidList,
			unidSccList: unidSccList,
			dgAttachementDetails:
				shippingItem?.code === "DOG" || shippingItem?.code === "CAT"
					? petsAttachmentList
					: dgarrayListDoc,
			crates: cageList,
			deletedCageIds: deletedCageIds,
			deletedPetIds: deletedPetIds,
			cargoFlightCheck: cargoFlights,
			aviBookingDetaills: aviBookingDetaills,
			dgbookcheck: dgbookcheck,
		};
		if (type === "continue") {
			if (
				priceCodeType === PRICE_CODE_TYPE.SPOT_RATE &&
				formData &&
				formData.spotRateCode &&
				formData.spotRateCode.length
			) {
				try {
					setIsLoading(true);
					const validateSpotRateResponse = await getValidateSpotRateResponse(
						formData
					);
					if (
						!validateSpotRateResponse.isApplicable &&
						validateSpotRateResponse.message
					) {
						updatePromoCodeError(
							MESSAGES.VALIDATE_SPOT_RATE_ERROR,
							i18n.getResource(
								"en",
								"errors",
								MESSAGES.VALIDATE_SPOT_RATE_ERROR
							)
						);
						setFooterErrorMsg(MESSAGES.VALIDATE_SPOT_RATE_ERROR);
						return;
					}
				} catch (err) {
					setFooterErrorMsg("ER143");
					updatePromoCodeError(
						"ER143",
						i18n.getResource("en", "errors", "ER143")
					);
					return;
				} finally {
					setIsLoading(false);
				}
			}

			//////Validate Promo code//////
			if (
				priceCodeType === PRICE_CODE_TYPE.PROMO_RATE &&
				formData &&
				formData.promoCode &&
				formData.promoCode.length
			) {
				try {
					setIsLoading(true);
					const promoCodeResponse = await getPromoCodeResponse(formData);
					if (!promoCodeResponse.isApplicable && promoCodeResponse.message) {
						updatePromoCodeError(
							MESSAGES.VALIDATE_PROMO_CODE_ERROR,
							i18n.getResource(
								"en",
								"errors",
								MESSAGES.VALIDATE_PROMO_CODE_ERROR
							)
						);
						setFooterErrorMsg(
							t(MESSAGES.VALIDATE_PROMO_CODE_ERROR, {
								promoCode: formData.promoCode,
								ns: "errors",
							})
						);
						return;
					}
				} catch (err) {
					updatePromoCodeError(
						"ER140",
						i18n.getResource("en", "errors", "ER140")
					);
					setFooterErrorMsg("ER140");
					return;
				} finally {
					setIsLoading(false);
				}
			}

			if (formData && formData.sccCodes && formData.sccCodes.length) {
				formData.originalSccCodes = formData.sccCodes;
				if (isModifyBooking) {
					let filteredSccs = formData.sccCodes.filter(function (
						scc,
						index,
						arr
					) {
						return !EXCEPTION_SCCS.includes(scc.scc);
					});
					formData.sccCodes = filteredSccs;
				}
				if (isCopyFlow) {
					formData.sccCodes = formData.sccCodes.filter(scc =>
						sccMaster.some(master => master.scc === scc.scc)
					);
					formData.isCopyFlow = true;
				}
				formData.sccCodes = removeDuplicates([...formData.sccCodes, EYP_SCC]);
			}
			setToSessionStorage(SessionKeys.SEARCH_FORM_DATA_BOOKING, getBase64Encoded(formData));
			setSearchFormDataToState(formData);
			if (searchFormData) {
				setSearchFormDataToState(formData);
			}
			if (
				shippingItem &&
				(shippingItem.product === FRESH_FORWARD_PRODUCT ||
					shippingItem.product === PHARMA_PRODUCT)
			) {
				// setPharmFormDataToState({
				//   additionalInfoData
				// })
				setToSessionStorage(
					"additionalFormData",
					getBase64Encoded(additionalInfoData)
				);
			}
			if (!isMultipleBookingEdit) {
				if (isModifyBooking) {
					//validateBookingRequest(awbNo, formData, null)
					clearItemFromSessionStorage("bookingDetails");



					// Validate Update Booking Request with loader
					setIsLoading(true);
					try {
						const alreadyEncodedData = getFromSessionStorage(SessionKeys.UPDATE_BOOKING_DATA);
						const { awbFlightDetails, additionalFlightDetails, initialAWBData } = alreadyEncodedData ? getBase64Decoded(alreadyEncodedData) : {};
						// Check for origin, destination, or shipping date change
						if (
							initialAWBData && (
								initialAWBData.origin !== selectedOrigin?.code ||
								initialAWBData.destination !== selectedDestination?.code ||
								(initialAWBData.shippingDate && shippingDate && !moment(initialAWBData.shippingDate, 'ddd DD MMM').isSame(moment(shippingDate), 'day'))
							)
						) {
							history.push({
								pathname: "/booking/flightlist",
								state: {
									modifyForm: true,
								},
							});
						} else {
							const response = await validateUpdateBooking(formData);
							const { errorDetails, referenceId, validateBookingResponseDto } = response?.responseDetails || {};
							if (errorDetails && errorDetails.length > 0) {
								// window.scrollTo(0, 0);
								// const errMsg = errorDetails[0]?.errorDescription || errorDetails[0]?.message || t("ER076", { ns: "errors" });
								// setNotificationMessage(errMsg);
								// setNotificationType(NOTIFICATION_MESSAGE_TYPE.ERROR);
								history.push({
									pathname: "/booking/flightlist",
									state: {
										modifyForm: true,
									},
								});
								return;
							} else if (validateBookingResponseDto?.validateBookingDetails) {
								const bookingDetailsFromValidate = mapValidateBookingToSelectedFlight(validateBookingResponseDto, awbFlightDetails, additionalFlightDetails);
								const modifiedBookingDetails = {
									referenceId: referenceId,
									awbFlightDetails: awbFlightDetails,
									additionalFlightDetails: additionalFlightDetails,
									initialAWBData: initialAWBData
								};
								setToSessionStorage(SessionKeys.UPDATE_BOOKING_DATA, getBase64Encoded(modifiedBookingDetails));
								setToSessionStorage(SessionKeys.SELECTED_FLIGHT_BOOKING, getBase64Encoded(bookingDetailsFromValidate));
								history.push({
									pathname: '/booking/summary',
								});
							} else {
								window.scrollTo(0, 0);
								setNotificationMessage(t("ER076", { ns: "errors" }));
								setNotificationType(NOTIFICATION_MESSAGE_TYPE.ERROR);
							}
						}
					} catch (error) {
						window.scrollTo(0, 0);
						setNotificationMessage(t("ER076", { ns: "errors" }));
						setNotificationType(NOTIFICATION_MESSAGE_TYPE.ERROR);
					} finally {
						setIsLoading(false);
					}


				} else {
					clearItemFromSessionStorage("bookingDetails");
					history.push("/booking/flightlist");
				}
			} else {
				clearItemFromSessionStorage("bookingDetails");
			}
		} else if (type === "saveDraft") {
			let unidInfoArray = [];
			formData?.unid?.filter((item, index) => {
				unidInfoArray.push({
					id: item?.id,
					unid: item?.unid,
					shippingName: item?.unidName,
					packingGroup: item?.packingGroup,
				});
			});

			const unidDetails =
				dgSccCode?.includes(shippingItem?.scc) || dgbookcheck
					? unidInfoArray
					: null;
			unidDetails === null
				? (formData.additionalCommodityDetail = null)
				: (formData.additionalCommodityDetail = {
					dangerousGoods: dgbookcheck ? dgbookcheck : true,
					specialProvision: true,
					unidInfo: unidDetails,
				});

			const specializedCommodity = [];

			formData?.dgAttachementDetails?.filter((item) => {
				specializedCommodity.push({
					attachmentId: item?.attachmentId,
					fileName: item?.fileName,
					id: item?.id,
				});
			});

			formData.specializedCommodity = specializedCommodity;

			let payload = {
				requestId: uuidv4(),
				formDraftParameters: formData,
				bookingDraft: {
					draftName: draftName,
					userId: userDetails.userId,
					draftDescription: draftName,
					agentCode: userDetails ? userDetails.agentCode : null,
					serialNumber:
						serialNumber && serialNumber !== "" ? parseInt(serialNumber) : 0,
				},
			};
			getSaveDraftResponse(payload);
			setToSessionStorage("savedDraftObject", getBase64Encoded(formData));
		} else if (type === "draftValues") {
			let unidInfoArray = [];
			formData?.unid?.filter((item, index) => {
				unidInfoArray.push({
					id: item?.id,
					unid: item?.unid,
					shippingName: item?.unidName,
					packingGroup: item?.packingGroup,
				});
			});
			const unidDetails =
				dgSccCode?.includes(shippingItem?.scc) || dgbookcheck
					? unidInfoArray
					: null;
			unidDetails === null
				? (formData.additionalCommodityDetail = null)
				: (formData.additionalCommodityDetail = {
					dangerousGoods: dgbookcheck,
					specialProvision: true,
					unidInfo: unidDetails,
				});

			const specializedCommodity = [];

			formData?.dgAttachementDetails?.filter((item) => {
				specializedCommodity.push({
					attachmentId: item?.attachmentId,
					fileName: item?.fileName,
					id: item?.id,
				});
			});

			formData.specializedCommodity = specializedCommodity;

			const encodedDraftSearchObject =
				getFromSessionStorage("savedDraftObject");
			let draftSavedObject = getBase64Decoded(encodedDraftSearchObject);

			if (
				draftSavedObject &&
				JSON.stringify(draftSavedObject) === JSON.stringify(formData)
			) {
				setNotLeave(false);
				setTimeout(() => {
					if (forInternalNav) {
						history.push(locationListened.pathname);
					} else {
						// setNotLeave(false)
						window.location.reload(true);
					}
				}, 1000);
			} else {
				// setNotLeave(true);
			}
		} else {
			if (formData && formData.totalWeightInKg === 0) {
				formData.totalWeightInKg = null;
			}

			let unidInfoArray = [];
			formData?.unid?.filter((item, index) => {
				unidInfoArray.push({
					id: item?.id,
					unid: item?.unid,
					shippingName: item?.unidName,
					packingGroup: item?.packingGroup,
				});
			});
			const unidDetails =
				dgSccCode?.includes(shippingItem?.scc) || dgbookcheck
					? unidInfoArray
					: null;
			unidDetails === null
				? (formData.additionalCommodityDetails = null)
				: (formData.additionalCommodityDetail = {
					dangerousGoods: dgbookcheck ? dgbookcheck : true,
					specialProvision: true,
					unidInfo: unidDetails,
				});
			let payload = {
				requestId: uuidv4(),
				formTemplateParameters: formData,
				bookingTemplate: {
					templateName: templateName,
					userId: userDetails.userId,
					templateDescription: templateName,
					agentCode: userDetails ? userDetails.agentCode : null,
					serialNumber:
						serialNumber && serialNumber !== "" ? parseInt(serialNumber) : 0,
				},
			};
			if (updateTemplateView) {
				const updateTemplateResponse = await updateTemplateDetails(
					payload,
					setIsLoading
				);
				handleTemplateAction(updateTemplateResponse, false);
			} else {
				getSaveTemplateResponse(payload);
			}
		}
	};

	useEffect(() => {
		(async () => {
			if (validateBookingResponse && validateBookingResponse.bookingDetails) {
				const bookingDetails = {
					bookingFlightDetails:
						validateBookingResponse.bookingDetails.bookingFlightDetails,
					rateDetails: validateBookingResponse.bookingDetails.rateDetails,
					shipmentDetails:
						validateBookingResponse.bookingDetails.shipmentDetails,
					awbNo: `${validateBookingResponse.bookingDetails.shipmentIdentifierDetails.shipmentPrefix}-${validateBookingResponse.bookingDetails.shipmentIdentifierDetails.masterDocumentNumber}`,
				};
				const encodedSearchObject = getFromSessionStorage("searchObject");
				let searchObject = null;
				let redirectToFlightSearch = false;
				if (encodedSearchObject && encodedSearchObject !== "null") {
					searchObject = getBase64Decoded(encodedSearchObject);
					let sccCodes = searchObject.sccCodes;
					let originalSccCodes = searchObject.originalSccCodes;
					const validateSccs = validateBookingResponse.bookingDetails.sccCodes;


					if (validateSccs && validateSccs.length) {
						if (validateSccs.includes(BIG_SCC.scc)) {
							const response = await checkIsBigOrOHG(
								searchObject,
								setIsLoading
							);
							if (response && response.bigShipment) {
								sccCodes = [...sccCodes, BIG_SCC];
								searchObject.bigShipment = true;
							}
						}
						if (validateSccs.includes(OHG_SCC.scc)) {
							sccCodes = [...sccCodes, OHG_SCC];
							searchObject.overHangShipment = true;
						}

						if (sccCodes.includes(FORCE_QUEUE_SCC.scc)) {
							searchObject.isForceQueued = true;
						}

						if (
							originalSccCodes &&
							originalSccCodes.length > 0 &&
							searchObject
						) {
							if (
								(originalSccCodes.includes(BIG_SCC.scc) ||
									originalSccCodes.includes(OHG_SCC.scc)) &&
								!searchObject.overHangShipment &&
								!searchObject.bigShipment
							) {
								redirectToFlightSearch = true;
							} else if (
								(searchObject.bigShipment || searchObject.overHangShipment) &&
								!originalSccCodes.includes(OHG_SCC.scc) &&
								!originalSccCodes.includes(BIG_SCC.scc)
							) {
								redirectToFlightSearch = true;
							}
						}
					}
					sccCodes = removeDuplicates(sccCodes);
					searchObject.sccCodes = sccCodes;
					setToSessionStorage("searchObject", getBase64Encoded(searchObject));
				}
				if (redirectToFlightSearch) {
					clearValidateBookingResponse();
					history.push({
						pathname: "/booking/flightlist",
					});
				} else {
					setToSessionStorage(
						"bookingDetails",
						getBase64Encoded(bookingDetails)
					);
					clearValidateBookingResponse();
					history.push({
						pathname: "/booking/summary",
						state: {
							isModifyBooking: isModifyBooking,
						},
					});
				}
			}
		})();
	}, [validateBookingResponse]);

	useEffect(() => {
		if (validateBookingError) {
			const error = validateBookingError;

			if (
				validateBookingError.errorCode &&
				VALIDATE_BOOKINGS_ERROR_CODES.includes(error.errorCode)
			) {
				setAlertMessage(
					`The booking could not be modified. ${error.description}`
				);
				addError(
					"VALIDATE_BOOKING_ERROR",
					`The booking could not be modified. ${error.description}`
				);
				setTemplateSuccess(false);
				window.scrollTo(0, 0);
				clearValidateBookingResponse();
			} else {
				clearItemFromSessionStorage("bookingDetails");
				clearValidateBookingResponse();
				history.push({
					pathname: "/booking/flightlist",
					state: {
						validationError: error.description,
					},
				});
			}
		}
	}, [validateBookingError]);

	const [saveTempError, setSaveTempError] = useState(null);
	const [alertMessage, setAlertMessage] = useState("");
	const [templateSuccess, setTemplateSuccess] = useState(false);

	//for drafts
	const [saveDraftsError, setSaveDraftError] = useState(null);
	const [alertMessageDraft, setAlertMessageDraft] = useState("");
	const [draftSuccess, setDraftSuccess] = useState(false);

	useEffect(() => {
		handleTemplateAction(saveTemplateResponse, true);
	}, [saveTemplateResponse]);

	const handleTemplateAction = (saveTemplateResponse, isSave) => {
		if (saveTemplateResponse) {
			let action = "modified";
			if (isSave === true) {
				action = "saved";
			}
			if (
				saveTemplateResponse.errorDetails &&
				saveTemplateResponse.errorDetails.length > 0
			) {
				setTemplateModal(false);
				setTemplateName("");
				setSaveTempError(null);
				setTemplateSuccess(false);
				if (action === "saved") {
					setAlertMessage(t(MESSAGES.TEMP_SAVE_FAILED, { ns: "errors" }));
					addError(
						MESSAGES.TEMP_SAVE_FAILED,
						i18n.getResource("en", "errors", MESSAGES.TEMP_SAVE_FAILED)
					);
				} else {
					setAlertMessage(t(MESSAGES.TEMP_MODIFY_FAILED, { ns: "errors" }));
					addError(
						MESSAGES.TEMP_MODIFY_FAILED,
						i18n.getResource("en", "errors", MESSAGES.TEMP_MODIFY_FAILED)
					);
				}
				window.scrollTo(0, 0);
			} else if (
				saveTemplateResponse.templateNameDuplicate &&
				saveTemplateResponse.templateNameDuplicate === true &&
				isSave === true
			) {
				setSaveTempError(MESSAGES.TEMP_NAME_EXISTS_ERROR);
				addError(
					MESSAGES.TEMP_NAME_EXISTS_ERROR,
					i18n.getResource("en", "errors", MESSAGES.TEMP_NAME_EXISTS_ERROR)
				);
			} else {
				setTemplateModal(false);
				setTemplateName("");
				setSaveTempError(null);
				if (isSave) {
					draftref.current = false;
					setTemplateSuccess(true);
					action === "saved"
						? setAlertMessage(t("SAVETMPLT.TMPLT_SAVE_SUCCESS"))
						: setAlertMessage(t("MNGTMPLT.MODIFY_SUCCESS"));
					getTemplates();
					window.scrollTo(0, 0);
					clearSaveTemplateResponse();
				} else {
					draftref.current = false;
					setNotLeave(false);
					const updateStatus = {
						message:
							action === "saved"
								? t("SAVETMPLT.TMPLT_SAVE_SUCCESS")
								: t("MNGTMPLT.MODIFY_SUCCESS"),
						success: true,
					};
					clearSaveTemplateResponse();
					history.push({
						pathname: "/manage-template",
						state: {
							updateStatus: updateStatus,
						},
					});
				}
			}
		}
	};

	const handleClear = (e) => {
		setSearchFormDataToState(null);
		setSelectedOrigin(defaultOrigin);
		setSelectedDestination(null);
		setShippingItem(null);
		// setPharmFormDataToState(null)
		setShippingDate(null);
		setArrivalDate(null);
		setLooseDetails([getInitLooseItemDetail()]);
		setULDDetails([getInitULDItemDetail()]);
		setMixLooseDetails([getInitLooseItemDetail()]);
		setShippingType(SHIPPING_TYPE.LOOSE);
		setLooseItemsTotalWeight("");
		setError(null);
		setPromoCode("");
		setSpotRateCode("");
		setSpotRateDetails(null);
		setAllStackable(true);
		setAllTiltable(false);
		setMixLooseDetails([getInitLooseItemDetail()]);
		setExpandAccordian(false);
		setWeightUnit(WEIGHT_UNIT.KILOGRAM);
		setDimensionUnit(DIMENSION_UNIT.CENTIMETERS);
		setAdditionalSccs([]);
		setCalculatedTotalWeight(0);
		setActualChargeableWeight(0);
		setTotalWeightInKg(0);
		setTemplateName("");
		setSerialNumber(null);
		setTemplateView(false);
		setUpdateTemplateView(false);
		setSaveTempError(null);
		setAlertMessage("");
		setTemplateSuccess(false);
		setSaveDraftError(null);
		setAdjustedWeight(null);
		setShowOpweight(false);
		clearItemFromSessionStorage("savedDraftObject");
		setCageLists([getInitCageDetails(weightUnit, dimensionUnit)]);
		setUnidList([getInitUnidDetail()]);
		setFlightDetailsError(new Map());
	};

	const handleClearSeasonal = (e) => {
		setSearchFormDataToState(null);
		setSelectedOrigin(defaultOrigin);
		setSelectedDestination(null);
		setShippingItem(null);
		// setPharmFormDataToState(null)
		setShippingDate(null);
		setArrivalDate(null);
		setLooseDetails([getInitLooseItemDetail()]);
		setULDDetails([getInitULDItemDetail()]);
		setMixLooseDetails([getInitLooseItemDetail()]);
		setShippingType(SHIPPING_TYPE.LOOSE);
		setLooseItemsTotalWeight("");
		setError(null);
		setPromoCode("");
		setSpotRateCode("");
		setSpotRateDetails(null);
		setAllStackable(true);
		setAllTiltable(false);
		setMixLooseDetails([getInitLooseItemDetail()]);
		setExpandAccordian(false);
		setWeightUnit(WEIGHT_UNIT.KILOGRAM);
		setDimensionUnit(DIMENSION_UNIT.CENTIMETERS);
		setAdditionalSccs([]);
		setCalculatedTotalWeight(0);
		setActualChargeableWeight(0);
		setTotalWeightInKg(0);
		setTemplateName("");
		setSerialNumber(null);
		setTemplateView(false);
		setUpdateTemplateView(false);
		setSaveTempError(null);
		setAlertMessage("");
		setTemplateSuccess(false);
		setSaveDraftError(null);
		setAdjustedWeight(null);
		setShowOpweight(false);
		clearItemFromSessionStorage("savedDraftObject");
		setCageLists([getInitCageDetails(weightUnit, dimensionUnit)]);
		setUnidList([getInitUnidDetail()]);
		setStartDate("");
		setEndDate("");
		setFlightList([getInitSeasonalFlightDetails()]);
	};

	//======= function for draft value comparison======//

	const handleDraftValueCallback = (isSave) => {
		if (
			looseItemsTotalWeight &&
			shippingType === SHIPPING_TYPE.LOOSE &&
			calculatedTotalWeight &&
			calculatedTotalWeight * 1 !== looseItemsTotalWeight * 1
		) {
			const tempLooseDetails = JSON.parse(JSON.stringify(looseDetails)).map(
				(dimDetails) => {
					return { ...dimDetails, weight: null };
				}
			);
			setLooseDetails([...tempLooseDetails]);
			initiateListFlightRequest(tempLooseDetails, "draftValues");
		} else {
			initiateListFlightRequest(null, "draftValues");
		}
	};

	//======= function for template saving======//

	const handleSaveTemplate = (isSave) => {
		if (isSave === true && templateName === "") {
			setSaveTempError(MESSAGES.MANDATORY_TEMP_NAME);
			return;
		}
		if (
			looseItemsTotalWeight &&
			shippingType === SHIPPING_TYPE.LOOSE &&
			calculatedTotalWeight &&
			calculatedTotalWeight * 1 !== looseItemsTotalWeight * 1
		) {
			const tempLooseDetails = JSON.parse(JSON.stringify(looseDetails)).map(
				(dimDetails) => {
					return { ...dimDetails, weight: null };
				}
			);
			setLooseDetails([...tempLooseDetails]);
			initiateListFlightRequest(tempLooseDetails, "saveTemplate");
		} else {
			initiateListFlightRequest(null, "saveTemplate");
		}
	};

	const handleSubmitDraft = (isSave) => {
		if (isSave === true && draftName === "") {
			setSaveDraftError(MESSAGES.MANDATORY_DRAFT_NAME);
			// return
		} else if (
			looseItemsTotalWeight &&
			shippingType === SHIPPING_TYPE.LOOSE &&
			calculatedTotalWeight &&
			calculatedTotalWeight * 1 !== looseItemsTotalWeight * 1
		) {
			const tempLooseDetails = JSON.parse(JSON.stringify(looseDetails)).map(
				(dimDetails) => {
					return { ...dimDetails, weight: null };
				}
			);
			setLooseDetails([...tempLooseDetails]);
			initiateListFlightRequest(tempLooseDetails, "saveDraft");
		} else {
			initiateListFlightRequest(null, "saveDraft");
		}
	};
	//=========================================//
	const handleSubmit = (e) => {
		e.preventDefault();

		// Check for BUP SCC and LOOSE shipping type
		const allSccs = [
			...(shipmentSccs || []),
			...(appliedSccs || []),
			...(additionalSccs || []),
			...(appliedServices || [])
		];

		if (checkIsApplyLooseRestriction(allSccs) && shippingType === SHIPPING_TYPE.LOOSE) {
			setShippingTypeError(`BUP (SHC) is allowed only for ULD bookings.`);
			setTimeout(() => setShippingTypeError(''), 5000);
			return;
		}

		setshowValidation(true);
		const errorObj = validateFormData({
			selectedOrigin,
			selectedDestination,
			isSearchByArrivalDate,
			shippingDate,
			arrivalDate,
			shippingItem,
			unid,
			specialProvisonErrorCheck,
			hasDangerous,
			hasDangerous1,
			unidList,
			shippingType,
			totalWeight: looseItemsTotalWeight,
			adjustedWeight: adjustedWeight,
			looseDetails,
			ULDDetails,
			additionalInfoData,
			calculatedTotalWeight,
			mixLooseDetails,
			expandAccordian,
			priceCodeType,
			priceCode:
				priceCodeType === PRICE_CODE_TYPE.PROMO_RATE ? promoCode : spotRateCode,
			isUnknownShipment,
			isUSBound,
			isLiveAnimalBooking:
				shippingItem?.code === "DOG" || shippingItem?.code === "CAT"
					? true
					: false,
			cageList: cageList,
		});

		setError(errorObj);

		if (
			!errorObj &&
			(sccCodeEntered === "" || typeof sccCodeEntered === "object") &&
			embargoErrorCheck &&
			specialProvisonErrorCheck
		) {
			setSccWarning(null);
			if (
				looseItemsTotalWeight &&
				shippingType === SHIPPING_TYPE.LOOSE &&
				calculatedTotalWeight &&
				calculatedTotalWeight * 1 !== looseItemsTotalWeight * 1
			) {
				const tempLooseDetails = JSON.parse(JSON.stringify(looseDetails)).map(
					(dimDetails) => {
						return { ...dimDetails, weight: null };
					}
				);
				setLooseDetails([...tempLooseDetails]);
				initiateListFlightRequest(tempLooseDetails, "continue");
			} else {
				initiateListFlightRequest(null, "continue");
			}
		} else if (
			sccCodeEntered !== "" &&
			typeof sccCodeEntered === "string" &&
			additionalSccs.length === 0
		) {
			setSccWarning(t(MESSAGES.VALID_ADD_SCC_CODE, { ns: "errors" }));
			setFooterErrorMsg(
				t(MESSAGES.CORRECT_ERRORS_BFR_CONTINUE, { ns: "errors" })
			);
		} else {
			setFooterErrorMsg(
				t(MESSAGES.CORRECT_ERRORS_BFR_CONTINUE, { ns: "errors" })
			);
		}
		//set files to session storage
		//setToSessionStorage('petFiles', getBase64Encoded(file))
		window.scrollTo(0, 350)
	};

	const [templateView, setTemplateView] = useState(false);
	const [updateTemplateView, setUpdateTemplateView] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isCAOChecked, setIsCAOChecked] = useState(false);

	const getTemplates = () => {
		if (userDetails && !updateTemplateView && !isModifyBooking) {
			const listRequest = {
				requestId: uuidv4(),
				agentCode: userDetails.agentCode,
			};
			const listDraftsRequest = {
				requestId: uuidv4(),
				userId: userDetails.userId,
			};

			getlistTemplateNamesResponse(listRequest);
			getlistDraftsResponse(listDraftsRequest);
		}
	};

	const handleAlertClose = () => {
		setAlertMessage("");
		setTemplateSuccess(false);
		setAlertMessageDraft("");
		setDraftSuccess(false);
	};

	const handleSccChange = (e) => {
		setSccCodeEntered(e?.target?.value);
	};

	const handleSetError = (key, text) => {
		error
			? setError({
				...error,
				[key]: text,
			})
			: setError({
				[key]: text,
			});
	};

	const getMaxShippingDate = (arrivalDate) => {
		const bookingWindowEndDate = moment().add(
			ALLOWABLE_BOOKING_DATE - 1,
			"days"
		);
		let maxShippingDate = bookingWindowEndDate;
		if (!arrivalDate) {
			return maxShippingDate.toDate();
		}

		const arrivalDateObj = moment(arrivalDate, "DD-MM-YYYY");
		if (arrivalDateObj.isBefore(maxShippingDate)) {
			maxShippingDate = arrivalDateObj;
		}
		return maxShippingDate.toDate();
	};

	const getSeasonalBookingFlightDetails = (flightData) => {
		// if (searchFormData.isModifyBooking && !selectedFlight) {
		// 	return searchFormData.bookingFlightDetails
		// }
		// else if (selectedFlight) {
		const flightDetails = flightData.map((flight, index) => ({
			segmentOrigin:
				index !== 0
					? flightData[index - 1].destination.code
					: selectedOrigin?.code,
			segmentDestination: flight?.destination?.code,
			segmentArrivalDate: null,
			segmentDepartureDate: null,
			carrierCode:
				!flight.flightNumber.toLowerCase().startsWith("ey") &&
					flight.flightNumber.match("[a-zA-Z]{2}")
					? flight.flightNumber[0] + flight.flightNumber[1]
					: "EY",
			flightNumber: flight.flightNumber.toLowerCase().startsWith("ey-")
				? flight.flightNumber.replace(/^ey-/i, "")
				: flight.flightNumber.toLowerCase().startsWith("ey")
					? flight.flightNumber.replace(/^ey\s*/i, "")
					: flight.flightNumber.match("[a-zA-Z]{2}-")
						? flight.flightNumber.replace(/^[a-zA-Z]{2}-/, "")
						: flight.flightNumber.match("[a-zA-Z]{2}")
							? flight.flightNumber.replace(/^[a-zA-Z]{2}/, "")
							: flight.flightNumber,
			flightDate: flight.flightDate
				? moment(flight.flightDate, "DD-MMM-YYYY").format("DD-MMM-YYYY")
				: null,
			allotmentId: flight?.allotmentId ? flight?.allotmentId : null,
		}));
		return flightDetails;
	};

	const getSccCodes = () => {
		return removeDuplicates([
			...shipmentSccs,
			...appliedSccs,
			...additionalSccs,
			...appliedServices,
		]).map((e) => e.scc);
	};

	const submitSeasonalBookingForm = () => {
		const seasonalFormData = {
			requestID: uuidv4(),
			saveMassBookingByTemplate: {
				bookingType: "Template",
				userId: userDetails.userId,
				agentCode: userDetails.agentCode,
				fileName: selectedTemplate,
				startDate: startDate
					? moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD")
					: null,
				endDate: endDate
					? moment(endDate, "YYYY-MM-DD").format("YYYY-MM-DD")
					: null,
				frequency: dateScheduler,
				onDay: weekdays,
				// allotmentId: flightList.map(flight => flight.allotmentId).filter(id => id !== "")
			},
			bookingDetails: {
				shipmentIdentifierDetails: null,
				weightUnit: weightUnit,
				volumeUnit: "B",
				dimensionUnit: dimensionUnit,
				promoCode:
					priceCodeType === PRICE_CODE_TYPE.PROMO_RATE &&
						promoCode &&
						promoCode.length
						? promoCode
						: null,
				spotRateCode:
					priceCodeType === PRICE_CODE_TYPE.SPOT_RATE &&
						spotRateCode &&
						spotRateCode.length
						? spotRateCode
						: null,
				shipmentDetails: {
					shipmentOrigin: selectedOrigin?.code,
					shipmentDestination: selectedDestination?.code,
					shippingDate: shippingDate
						? moment(shippingDate, "DD-MMM-YYYY").format("DD-MMM-YYYY")
						: null,
					agentCode: userDetails.agentCode ? userDetails.agentCode : null,
					customerCode: userDetails ? userDetails.customerCode : null,
					currency: userDetails ? userDetails.currencyCode : null,
					productDetails: {
						productName: shippingItem ? shippingItem.product : null,
					},
				},
				sccCodes: getSccCodes(),
				bookingCommodityDetails: [
					{
						commodityCode: shippingItem?.code,
						pieces: totalPieces,
						weight: totalWeightInKg,
						volume:
							Number(totalVolumeInMtrs).toFixed(2) > 0.01
								? Number(totalVolumeInMtrs).toFixed(2)
								: 0.01,
						shipmentDescription: shippingItem?.description,
						adjustedWeight: adjustedWeight
							? round(
								calculateWeightToKg(
									Number(adjustedWeight),
									searchFormData?.weightUnit
								),
								2
							)
							: 0,
					},
				],
				bookingFlightDetails: getSeasonalBookingFlightDetails(flightList),
				spotRate: null,
				allInRate: null,
				isSpotRateRequired: "N",
				specializedCommodity: [],
				additionalCommodityDetails: null,
			},
		};

		//setting dimenstion details
		if (shippingType === SHIPPING_TYPE.LOOSE) {
			seasonalFormData.bookingDetails.bookingCommodityDetails[0].dimensionDetaills =
				[];
			looseDetails.forEach(function (element) {
				if (element.pieces > 0) {
					const weight = Number(element.weight)
						? Number(element.weight).toFixed(2)
						: 0;
					const weightType = !Number(element.weight)
						? DETAILS_APPLY_FOR.TOTAL
						: element.weightType;
					let formattedItemDetail = {
						length: element.length,
						height: element.height,
						width: element.width,
						numberOfPieces: element.pieces,
						weight:
							weightType === DETAILS_APPLY_FOR.PER_ITEM
								? weight * element.pieces
								: weight,
						tiltable: !element.turnable ? "N" : "Y",
						stackable: !element.stackable ? "N" : "Y",
					};
					seasonalFormData.bookingDetails.bookingCommodityDetails[0].dimensionDetaills.push(
						formattedItemDetail
					);
				}
			});
		} else {
			seasonalFormData.bookingDetails.bookingCommodityDetails[0].uldInfoDetaills =
				[];
			ULDDetails.forEach(function (element) {
				if (element.pieces > 0) {
					let formattedItemDetail = {
						uldType: element.uldType,
						numberOfUlds: element.pieces,
						uldWeight: element.weight,
						uldVolume: element.uldVolume,
						contour: element.contour,
					};
					seasonalFormData.bookingDetails.bookingCommodityDetails[0].uldInfoDetaills.push(
						formattedItemDetail
					);
				}
			});
			if (
				mixLooseDetails &&
				mixLooseDetails.length > 0 &&
				mixLooseDetails[0].weight !== ""
			) {
				seasonalFormData.bookingDetails.bookingCommodityDetails[0].dimensionDetaills =
					[];
				mixLooseDetails.forEach(function (element) {
					if (element.pieces > 0) {
						const weight = !Number(element.weight)
							? Number(totalWeightInKg) / mixLooseDetails.length
							: Number(element.weight);
						const weightType = !Number(element.weight)
							? DETAILS_APPLY_FOR.TOTAL
							: element.weightType;
						let formattedItemDetail = {
							length: element.length,
							height: element.height,
							width: element.width,
							numberOfPieces: element.pieces,
							weight:
								weightType === DETAILS_APPLY_FOR.PER_ITEM
									? weight * element.pieces
									: weight,
							tiltable: !element.turnable ? "N" : "Y",
							stackable: !element.stackable ? "N" : "Y",
						};
						seasonalFormData.bookingDetails.bookingCommodityDetails[0].dimensionDetaills.push(
							formattedItemDetail
						);
					}
				});
			}
		}

		//checkErrors
		const errorObj = validateSeasonalBooking({
			seasonalFormData,
			selectedOrigin,
			selectedDestination,
			startDate,
			endDate,
			unidList,
			shippingItem,
			hasDangerous,
			hasDangerous1,
			flightList,
			shippingType,
			totalWeight: looseItemsTotalWeight,
			adjustedWeight: adjustedWeight,
			calculatedTotalWeight,
			isLiveAnimalBooking:
				shippingItem?.code === "DOG" || shippingItem?.code === "CAT"
					? true
					: false,
			looseDetails,
			ULDDetails,
			mixLooseDetails,
			expandAccordian,
			isAllotmentRequired,
			isAllotmentRequiredFlightDate,
			dateScheduler,
			weekdays,
			indexArray,
		});
		setSeasonalError(errorObj);
		setError(errorObj);
		if (!errorObj) {
			//call seasonal booking submit api
			setIsLoading(true);
			saveSeasonalBooking(seasonalFormData).then((response) => {
				if (response.data.status === "success") {
					setInitialList();
					setListPageOpen(true);
					setIsLoading(false);
				}
			});
		} else {
			setIsLoading(false);
			setFooterErrorMsg(
				t(MESSAGES.CORRECT_ERRORS_BFR_CONTINUE, { ns: "errors" })
			);
		}

		//dimension details
	};
	useEffect(() => {
		if (searchFormData) {
			setTimeout(() => {
				if (searchFormData?.dgbookcheck && shippingItem !== null) {
					setDgbookcheck(true);
				}
				if (searchFormData?.dgAttachementDetails?.length > 0) {
					let dgData = [...searchFormData?.dgAttachementDetails];
					setDgArrayListDoc(dgData);
				}
			}, 1000);
			if (searchFormData?.unid?.length > 0) {
				let unidData = [...searchFormData.unid];
				setTimeout(() => {
					setUnidList(unidData);
					if (searchFormData?.unidSccList?.length > 0) {
						setUnidSccList(searchFormData.unidSccList);
					}
				}, 800);
			}
		}
	}, [searchFormData]);


	// Keep last non-empty flight details for fallback 
	const lastNonEmptyFlightDetailsRef = useRef([]);
	useEffect(() => {
		const hasValidSeg = (seg) =>
			!!(seg?.flightNumber ||
				seg?.origin?.code ||
				seg?.destination?.code ||
				seg?.segmentOrigin ||
				seg?.segmentDestination ||
				seg?.flightDate);
		if (Array.isArray(flightDetailsData) && flightDetailsData.some(hasValidSeg)) {
			lastNonEmptyFlightDetailsRef.current = flightDetailsData.map((s) => ({ ...s }));
		}
	}, [flightDetailsData]);

	const handleMutlipleBookSaveChange = async () => {
		//  BUP+LOOSE restriction 
		const allSccs = [
			...(shipmentSccs || []),
			...(appliedSccs || []),
			...(additionalSccs || []),
			...(appliedServices || [])
		];

		if (checkIsApplyLooseRestriction(allSccs) && shippingType === SHIPPING_TYPE.LOOSE) {
			setShippingTypeError(`BUP (SHC) is allowed only for ULD bookings.`);
			setTimeout(() => setShippingTypeError(''), 5000);
			return;
		}

		const errorObj = validateFormData({
			selectedOrigin,
			selectedDestination,
			isSearchByArrivalDate,
			shippingDate,
			arrivalDate,
			shippingItem,
			unid,
			specialProvisonErrorCheck,
			hasDangerous,
			hasDangerous1,
			unidList,
			shippingType,
			totalWeight: looseItemsTotalWeight,
			adjustedWeight: adjustedWeight,
			looseDetails,
			ULDDetails,
			additionalInfoData,
			calculatedTotalWeight,
			mixLooseDetails,
			expandAccordian,
			priceCodeType,
			priceCode:
				priceCodeType === PRICE_CODE_TYPE.PROMO_RATE ? promoCode : spotRateCode,
			isUnknownShipment,
			isUSBound,
			isLiveAnimalBooking:
				shippingItem?.code === "DOG" || shippingItem?.code === "CAT"
					? true
					: false,
			cageList: cageList,
			isMutlipleBooking: true,
			awbPrefix,
			awbNumber
		});
		const flightError = validateMutlipleBookingFlightData(flightDetailsData);
		if (errorObj || flightError) {
			setError(errorObj);
			setFlightDetailsError(flightError);
			setFooterErrorMsg(
				t(MESSAGES.CORRECT_ERRORS_BFR_CONTINUE, { ns: "errors" })
			);
		} else {
			// Snapshot segments BEFORE any state mutations
			const snapshot = Array.isArray(flightDetailsData) ? flightDetailsData.map((s) => ({ ...s })) : [];
			const hasValidSeg = (seg) =>
				!!(seg?.flightNumber ||
					seg?.origin?.code ||
					seg?.destination?.code ||
					seg?.segmentOrigin ||
					seg?.segmentDestination ||
					seg?.flightDate);
			const baseSegments = snapshot.some(hasValidSeg)
				? snapshot
				: lastNonEmptyFlightDetailsRef.current.map((s) => ({ ...s })); // fallback

			setIsLoading(true);
			await initiateListFlightRequest(null, "continue");


			const editedPrefix = (awbPrefix || "").trim();
			const editedNumber = (awbNumber || "").trim();
			const apiDataObj = getResumbitRequestBody(flightDetailsData, userDetails, editedNumber != null && editedNumber.trim().length != 0 ? `${editedPrefix}-${editedNumber}` : "");

			// Normalize and apply segments from snapshot/fallback (NEW)
			const normalizedSegments = baseSegments
				.filter(hasValidSeg)
				.map((seg) => {
					const formattedDate = seg?.flightDate
						? moment(seg.flightDate, ["DD-MMM-YYYY", "YYYY-MM-DD", moment.ISO_8601]).format("DD-MMM-YYYY")
						: null;

					const flightNumber = seg?.flightNumber || null;
					const carrierCode = flightNumber?.match(/^[A-Za-z]{2}/)?.[0]?.toUpperCase() || "EY";
					const normalizedNumber = flightNumber
						? flightNumber.replace(/^[A-Za-z]{2}[-\s]?/i, "")
						: null;

					const segOrigin = seg?.segmentOrigin || seg?.origin?.code || selectedOrigin?.code || null;
					const segDestination = seg?.segmentDestination || seg?.destination?.code || selectedDestination?.code || null;

					return {
						segmentOrigin: segOrigin,
						segmentDestination: segDestination,
						carrierCode,
						flightNumber: normalizedNumber,
						flightDate: formattedDate,
						allotmentId: seg?.allotmentId || null,
						...seg,
						flightDate: formattedDate,
						carrierCode,
						flightNumber: normalizedNumber,
						segmentOrigin: segOrigin,
						segmentDestination: segDestination,
					};
				});

			apiDataObj.bookingDetails = apiDataObj.bookingDetails || {};
			if (normalizedSegments.length > 0) {
				apiDataObj.bookingDetails.bookingFlightDetails = normalizedSegments; // NEW
			}

			// Keep shipmentDetails.shippingDate aligned to the current UI shippingDate or first segment date
			apiDataObj.bookingDetails.shipmentDetails = apiDataObj.bookingDetails.shipmentDetails || {};
			apiDataObj.bookingDetails.shipmentDetails.shipmentOrigin = selectedOrigin?.code || apiDataObj.bookingDetails.shipmentDetails.shipmentOrigin || null;
			apiDataObj.bookingDetails.shipmentDetails.shipmentDestination = selectedDestination?.code || apiDataObj.bookingDetails.shipmentDetails.shipmentDestination || null;

			const formattedShippingDate = shippingDate
				? moment(shippingDate, ["DD-MMM-YYYY", "YYYY-MM-DD", moment.ISO_8601]).format("DD-MMM-YYYY")
				: null;
			const firstSegDate =
				apiDataObj.bookingDetails.bookingFlightDetails?.[0]?.flightDate ||
				normalizedSegments?.[0]?.flightDate ||
				null;

			apiDataObj.bookingDetails.shipmentDetails.shippingDate =
				formattedShippingDate || firstSegDate || apiDataObj.bookingDetails.shipmentDetails.shippingDate || null;

			// Product details from UI
			const uiProductName =
				shippingItem?.serviceProduct
				?? shippingItem?.product
				?? apiDataObj.bookingDetails.shipmentDetails?.productDetails?.productName
				?? null;

			apiDataObj.bookingDetails.shipmentDetails.productDetails = {
				...(apiDataObj.bookingDetails.shipmentDetails.productDetails || {}),
				productName: uiProductName
			};

			// Make sure bookingCommodityDetails matches the current shipping item selection
			if (Array.isArray(apiDataObj.bookingDetails.bookingCommodityDetails) && apiDataObj.bookingDetails.bookingCommodityDetails.length > 0) {
				const commodity = { ...apiDataObj.bookingDetails.bookingCommodityDetails[0] };
				if (shippingItem?.code) commodity.commodityCode = shippingItem.code;
				if (shippingItem?.description) commodity.shipmentDescription = shippingItem.description;
				apiDataObj.bookingDetails.bookingCommodityDetails[0] = commodity;
			}

			if (editedPrefix && editedNumber) {
				const editedAwbFull = `${editedPrefix}-${editedNumber}`;
				apiDataObj.awbNumber = editedAwbFull;

				apiDataObj.bookingDetails = apiDataObj.bookingDetails || {};
				const prevSid = apiDataObj.bookingDetails.shipmentIdentifierDetails || {};
				apiDataObj.bookingDetails.shipmentIdentifierDetails = {
					...prevSid,
					shipmentPrefix: editedPrefix,
					masterDocumentNumber: editedNumber,
				};

				try {
					const encoded = getFromSessionStorage(sessionKeys.MULTIPLE_BOOKING_DATA);
					if (encoded) {
						const decoded = getBase64Decoded(encoded);
						const fullBookingData = decoded?.fullBookingData || {};
						const bookingDetails = fullBookingData?.bookingDetails || {};
						const sid = bookingDetails?.shipmentIdentifierDetails || {};
						const newPayload = {
							...decoded,
							fullBookingData: {
								...fullBookingData,
								awbNumber: editedAwbFull,
								bookingDetails: {
									...bookingDetails,
									shipmentIdentifierDetails: {
										...sid,
										shipmentPrefix: editedPrefix,
										masterDocumentNumber: editedNumber
									}
								}
							}
						};
						setToSessionStorage(sessionKeys.MULTIPLE_BOOKING_DATA, getBase64Encoded(newPayload));
					}
				} catch (e) {
					console.warn("Failed to persist edited AWB to session", e);
				}
			}
			let reprocessStatus = "falied";
			try {
				await reprocessPermanentbooking(apiDataObj).then((response) => {
					if (response && response?.status === 200) {
						setIsLoading(false);
						reprocessStatus = "success";
					} else {
						setIsLoading(false);
					}
				});
			} catch (error) {
				setIsLoading(false);
				console.error("Reprocess booking failed:", error);
			}
			history.push({
				pathname: "/permanent-booking",
				state: {
					reprocessStatus,
					bookingGrpId: apiDataObj?.bookingGrpId,
				},
			});
		}
	};

	const [awbPrefix, setAwbPrefix] = useState(
		searchFormData?.shipmentIdentifierDetails?.shipmentPrefix || ""
	);
	const [awbNumber, setAwbNumber] = useState(
		searchFormData?.shipmentIdentifierDetails?.masterDocumentNumber || ""
	);

	useEffect(() => {
		if (awbPrefix || awbNumber) return;
		const encoded = getFromSessionStorage(sessionKeys.MULTIPLE_BOOKING_DATA);
		if (!encoded) return;
		let decoded;
		try { decoded = getBase64Decoded(encoded); } catch { return; }
		const fullBookingData = decoded?.fullBookingData;
		if (!fullBookingData) return;
		const sid = fullBookingData?.bookingDetails?.shipmentIdentifierDetails || {};
		let prefix = (sid?.shipmentPrefix || "").trim();
		let number = (sid?.masterDocumentNumber || "").trim();
		if ((!prefix || !number) && typeof fullBookingData?.awbNumber === "string") {
			const raw = fullBookingData.awbNumber.trim();
			const parts = raw.includes("-") ? raw.split("-") : [raw.slice(0, 3), raw.slice(3)];
			prefix = prefix || (parts[0] || "").trim();
			number = number || (parts[1] || "").trim();
		}
		setAwbPrefix(prefix || "");
		setAwbNumber(number || "");
	}, []);

	const handleAwbPrefixChange = (val) => {
		const numeric = (val || "").replace(/\D/g, "").slice(0, 3);
		setAwbPrefix(numeric);
	};

	const handleAwbNumberChange = (val) => {
		const numeric = (val || "").replace(/\D/g, "");
		setAwbNumber(numeric);
	};

	//==========================================================//
	return (
		<BeforeClosePrompt
			history={history}
			isModifyBooking={isModifyBooking}
			saveDraftError={saveDraftsError}
			saveDraftResponse={saveDraftResponse}
			setSaveDraftError={setSaveDraftError}
			setAlertMessage={setAlertMessageDraft}
			setDraftSuccess={setDraftSuccess}
			notLeave={notLeave}
			setNotLeave={setNotLeave}
			acceptFunction={() => handleSubmitDraft(true)}
			setName={setDraftName}
			name={draftName}
			getTemplates={getTemplates}
			clearSaveDraftResponse={clearSaveDraftResponse}
			handleDraftValueCallback={handleDraftValueCallback}
			setLocationListened={setLocationListened}
			locationListened={locationListened}
			setForInternalNav={setForInternalNav}
			disableBeforeClosePrompt={disableBeforeClosePrompt}
			component={
				<div className="search-panel">
					<SearchHeader
						searchFormData={searchFormData}
						setNotLeave={setNotLeave}
						updateTemplateView={updateTemplateView}
						setUpdateTemplateView={setUpdateTemplateView}
						templateParam={templateParam}
						serialNo={serialNo}
						listTemplateNamesResponse={listTemplateNamesResponse}
						listDraftsResponse={listDraftsResponse}
						setSearchFormDataToState={setSearchFormDataToState}
						setAdditionalInfoData={setAdditionalInfoData}
						setIsLoading={setIsLoading}
						setTemplateView={setTemplateView}
						setTemplateName={setTemplateName}
						setSerialNumber={setSerialNumber}
						shippingItems={shippingItems}
						handleClear={handleClear}
						isModifyBooking={isModifyBooking}
						awbNo={awbNo}
						setAlertMessage={setAlertMessage}
						setTemplateSuccess={setTemplateSuccess}
						setArrivalDate={setArrivalDate}
						getlistDraftsResponse={getlistDraftsResponse}
						listQuotesResponse={listQuotesResponse}
						listQuoteError={listQuoteError}
						listTemplateNamesError={listTemplateNamesError}
						listDraftsError={listDraftsError}
						setSelectedTemplate={setSelectedTemplate}
						selectedTemplate={selectedTemplate}
						isSeasonalBooking={isSeasonalBooking}
						setInitialList={setInitialList}
						navigateBack={navigateBack}
						isMultipleBookingEdit={isMultipleBookingEdit}
					/>
					{alertMessage && alertMessage !== "" && (
						<Alert
							isError={!templateSuccess}
							showAlert={true}
							message={t(alertMessage, { ns: "errors" })}
							setTimeout={true}
							onAlertClose={handleAlertClose}
						/>
					)}
					{alertMessageDraft && alertMessageDraft !== "" && (
						<Alert
							isError={!draftSuccess}
							showAlert={true}
							message={t(alertMessageDraft, { ns: "errors" })}
							setTimeout={true}
							onAlertClose={handleAlertClose}
						/>
					)}

					{!(
						isSeasonalBooking &&
						(
							listTemplateNamesResponse?.templateList?.length == 0 ||
							selectedTemplate === null ||
							selectedTemplate?.trim()?.length === 0
						)
					) && (
							<form className="new-booking-container">
								<div className="form-container-shippingdetails">
									<h3>{t("BOOKING.SHIPPING_DETAILS")}</h3>
									<div className="form-container ">
										{/* First row - Origin and Destination */}
										<div className="shipping-deparr-row">
											<div
												className={`form-group common-autocomplete ${error && error[FORM_FIELDS.ORIGIN] ? "red-border" : ""
													}`}
											>
												<div className="p-float-label input-wrapper">
													<AirportAutocomplete
														inputId="origin-airport"
														autoCompleteType={AUTOCOMPLETE_TYPE.ORIGIN}
														selectedOrigin={selectedOrigin}
														selectedDestination={selectedDestination}
														setSelectedOrigin={setSelectedOrigin}
														handleSetError={handleSetError}
														clearError={clearError}
														draftCallback={draftCallback}
														setNotificationMessage={setNotificationMessage}
														setNotificationType={setNotificationType}
													/>
													<label htmlFor="origin-airport">
														{t("COMMON.SHP_FROM")}
													</label>
												</div>
												<span className="search-panel__errormsg">
													{error && error[FORM_FIELDS.ORIGIN]
														? t(error[FORM_FIELDS.ORIGIN], { ns: "errors" })
														: ""}
												</span>
											</div>

											<div
												className={`form-group common-autocomplete ${error && error[FORM_FIELDS.DESTINATION]
													? "red-border"
													: ""
													}`}
											>
												<div className="p-float-label input-wrapper">
													<AirportAutocomplete
														inputId="destination-airport"
														autoCompleteType={AUTOCOMPLETE_TYPE.DESTINATION}
														selectedOrigin={selectedOrigin}
														selectedDestination={selectedDestination}
														setSelectedDestination={setSelectedDestination}
														handleSetError={handleSetError}
														clearError={clearError}
														displaySimilarBooking={
															!updateTemplateView && !isModifyBooking
														}
														setNotLeave={setNotLeave}
														draftCallback={draftCallback}
														setNotificationMessage={setNotificationMessage}
														setNotificationType={setNotificationType}
													/>
													<label htmlFor="destination-airport">
														{t("COMMON.SHP_TO")}
													</label>
												</div>
												<span className="search-panel__errormsg">
													{error && error[FORM_FIELDS.DESTINATION]
														? t(error[FORM_FIELDS.DESTINATION], { ns: "errors" })
														: ""}
												</span>
											</div>
										</div>
										{isSeasonalBooking ? (
											<SchedulerMultiFlightsContainer
												startDate={startDate}
												setStartDate={setStartDate}
												endDate={endDate}
												setEndDate={setEndDate}
												flightList={flightList}
												setFlightList={setFlightList}
												flightSelectedOrigin={flightSelectedOrigin}
												setFlightSelectedOrigin={setFlightSelectedOrigin}
												flightsMaxShippingDate={flightsMaxShippingDate}
												setFlightsMaxShippingDate={setFlightsMaxShippingDate}
												flightsMinDate={flightsMinDate}
												setFlightsMinDate={setFlightsMinDate}
												isAllotmentRequired={isAllotmentRequired}
												isAllotmentRequiredFlightDate={
													isAllotmentRequiredFlightDate
												}
												setIsAllotmentRequired={setIsAllotmentRequired}
												setIsAllotmentRequiredFlightDate={
													setIsAllotmentRequiredFlightDate
												}
												indexArray={indexArray}
												schedulerMaxShippingDate={schedulerMaxShippingDate}
												setSchedulerMaxShippingDate={setSchedulerMaxShippingDate}
												schedulerMinDate={schedulerMinDate}
												setSchedulerMinDate={setSchedulerMinDate}
												weekdays={weekdays}
												setWeekdays={setWeekdays}
												dateScheduler={dateScheduler}
												setDateScheduler={setDateScheduler}
												seasonalError={seasonalError}
												setSeasonalError={setSeasonalError}
												selectedDestination={selectedDestination}
											/>
										) : (
											<>
												{!isMultipleBookingEdit && (
													<div className="shipping-datetype-row">
														<label className="sub-head-label">
															{t("BOOKING.DATE_TYPE")}
														</label>
														<RadioToggle
															checkedArray={[
																!isSearchByArrivalDate,
																isSearchByArrivalDate,
															]}
															valueArray={[
																SEARCH_DATE_TOGGLE_TYPE.SHIPPING_DATE,
																SEARCH_DATE_TOGGLE_TYPE.ARRIVAL_DATE,
															]}
															labelArray={["COMMON.SHP_DATE", "COMMON.ARR_DATE"]}
															className="search-date-toggle"
															onChangeArray={[
																() => {
																	setIsSearchByArrivalDate(false);
																	setArrivalDate(null);
																	handleSetError(FORM_FIELDS.SHIPPING_DATE, null);
																},
																() => {
																	setIsSearchByArrivalDate(true);
																	setShippingDate(null);
																	handleSetError(FORM_FIELDS.SHIPPING_DATE, null);
																},
															]}
														/>
													</div>
												)}
												{/* Row for Arrival Date calendar input */}
												{isSearchByArrivalDate && (
													<div className={`shipping-shpdate-row mb-2`}>
														<div className={`form-group calendar-group `}>
															<AppCalendar
																id="arrival-date"
																value={arrivalDate}
																onChangeHandler={(arrivalDate) => {
																	setArrivalDate(arrivalDate);
																	if (arrivalDate) {
																		const errorObj = error ? { ...error } : {};
																		errorObj[FORM_FIELDS.ARRIVAL_DATE] = null;
																		errorObj[FORM_FIELDS.SHIPPING_DATE] = null;
																		setError(errorObj);
																	}
																}}
																onFocusHandler={() =>
																	clearError(FORM_FIELDS.ARRIVAL_DATE)
																}
																minDate={moment().toDate()}
																maxDate={moment()
																	.add(ALLOWABLE_BOOKING_DATE + 1, "days")
																	.toDate()}
																onErrorHandler={() =>
																	handleSetError(
																		FORM_FIELDS.ARRIVAL_DATE,
																		MESSAGES.INVALID_ARRIVAL_DATE
																	)
																}
																label={t("COMMON.ARR_DATE")}
																error={
																	error?.[FORM_FIELDS.ARRIVAL_DATE]
																		? t(error[FORM_FIELDS.ARRIVAL_DATE], {
																			ns: "errors",
																		})
																		: ""
																}
															/>
														</div>

														{arrivalDate && (
															<div
																className={`form-group calendar-group date-extra-session `}
															>
																{/* Show label when arrival date is selected */}

																<AppCalendar
																	id="shipping-date"
																	value={shippingDate}
																	onChangeHandler={(shippingDate) => {
																		setShippingDate(shippingDate);
																	}}
																	onFocusHandler={() =>
																		clearError(FORM_FIELDS.SHIPPING_DATE)
																	}
																	minDate={moment().toDate()}
																	maxDate={maxShippingDate}
																	label={t("BOOKING.SEARCH_BY_ARR_DATE")}
																	onErrorHandler={() =>
																		handleSetError(
																			FORM_FIELDS.SHIPPING_DATE,
																			MESSAGES.INVALID_SHIPPING_DATE
																		)
																	}
																	error={
																		error?.[FORM_FIELDS.SHIPPING_DATE]
																			? t(error[FORM_FIELDS.SHIPPING_DATE], {
																				ns: "errors",
																			})
																			: ""
																	}
																/>
															</div>
														)}
													</div>
												)}
												{!isSearchByArrivalDate && (
													<div className={`shipping-shpdate-row mb-2`}>
														<div className={`form-group calendar-group`}>
															{/* Show label when arrival date is selected */}
															<AppCalendar
																id="shipping-date"
																value={shippingDate}
																onChangeHandler={(shippingDate) => {
																	setShippingDate(shippingDate);
																}}
																onFocusHandler={() =>
																	clearError(FORM_FIELDS.SHIPPING_DATE)
																}
																minDate={moment().toDate()}
																maxDate={maxShippingDate}
																label={t("COMMON.SHP_DATE")}
																onErrorHandler={() =>
																	handleSetError(
																		FORM_FIELDS.SHIPPING_DATE,
																		MESSAGES.INVALID_SHIPPING_DATE
																	)
																}
																error={
																	error?.[FORM_FIELDS.SHIPPING_DATE]
																		? t(error[FORM_FIELDS.SHIPPING_DATE], {
																			ns: "errors",
																		})
																		: ""
																}
															/>
														</div>
														{!isMultipleBookingEdit && (
															<CommonDropDown
																label={t("COMMON.PREFERRED_SHIPMENT_TIME")}
																id={'dim-unit-dropdown'}
																value={preferredShipmentTime}
																options={timeOptions}
																onChange={(e) => setPreferredShipmentTime(e.target.value)}
																className={'form-group unit-type'}
															/>
														)}
														{isMultipleBookingEdit && (
															<div className="input-row">
																<div className={`form-group awb-input-section`}>
																	<CommonInput
																		type="text"
																		inputType="number"
																		label={t("COMMON.PREFIX")}
																		value={awbPrefix}
																		maxLength="3"
																		onChange={(e) => handleAwbPrefixChange(e?.target?.value)}

																		wrapperClassName="awb-prefix"
																		error={
																			error && error[FORM_FIELDS.AWB_PREFIX]
																				? error[FORM_FIELDS.AWB_PREFIX]
																				: ""
																		}
																	/>
																	<CommonInput
																		type="text"
																		inputType="number"
																		label={t("COMMON.AWB_NUMBER")}
																		value={awbNumber}
																		onChange={(e) => handleAwbNumberChange(e?.target?.value)}

																		wrapperClassName="awb-suffix"
																		isOnlyErrorBorder
																	/>
																</div>
															</div>
														)}
													</div>
												)}
											</>
										)}
									</div>
								</div>
								{isMultipleBookingEdit && (
									<MutlipleBookingFlightSection
										flightDetailsData={flightDetailsData}
										setFlightDetailsData={setFlightDetailsData}
										setNotificationMessage={setNotificationMessage}
										setNotificationType={setNotificationType}
										flightDetailsError={flightDetailsError}
										setFlightDetailsError={setFlightDetailsError}
										isMultipleBookingEdit={isMultipleBookingEdit}

									/>
								)}

								<div className="form-container-cargoDetails">
									<h3 className="cargodetails">{t("BOOKING.CARGO_DETAILS")}</h3>
									<div className="form-container">
										<>
											<div
												className={`cargo-depshc-row  ${recommendedServices?.length !== 0 ||
													(shipmentSccs && shipmentSccs.length) ||
													(additionalSccs && additionalSccs.length) ||
													(additionalSccs && additionalSccs.length) ||
													(appliedSccs && appliedSccs.length)
													? "extra-margin"
													: ""
													}`}
											>
												<div
													className={`form-group position-relative common-autocomplete ${error && error[FORM_FIELDS.SHIPPING_ITEM]
														? "red-border"
														: ""
														}`}
												>
													<div
														className={`p-float-label input-wrapper ${shippingItem ? "p-filled" : ""
															} ${isShippingFocused ? "p-focus" : ""}`}
													>
														<ShippingItemAutocomplete
															inputId={FORM_FIELDS.SHIPPING_ITEM}
															fieldType="SHIPPING_ITEM"
															selectedShippingItem={shippingItem}
															setSelectedShippingItem={setShippingItem}
															error={error}
															clearError={clearError}
															setError={setError}
															shippingItems={shippingItems}
															setDisplayShippingItemPopup={
																setDisplayShippingItemPopup
															}
															draftCallback={draftCallback}
															hoverColor="#f9f9f9"
															onFocusChange={setIsShippingFocused}
														/>

														<label
															htmlFor={FORM_FIELDS.SHIPPING_ITEM}
															className="shipping-autocmplte-label"
														>
															{t("COMMON.SHP_ITEM")}
														</label>
													</div>

													<span className="search-panel__errormsg">
														{error?.[FORM_FIELDS.SHIPPING_ITEM]
															? t(error[FORM_FIELDS.SHIPPING_ITEM], {
																ns: "errors",
															})
															: ""}
													</span>

													{/* {(shipmentSccs && shipmentSccs.length) ||
														(additionalSccs && additionalSccs.length) ||
														(additionalSccs && additionalSccs.length) ||
														(appliedSccs && appliedSccs.length) ? (
														<>
															<div className="scc-row">
																<SccListDisplay
																	nonRemovableSccs={[
																		...(shipmentSccs || []),
																		...(appliedSccs || []),
																	]}
																	additionalSccs={additionalSccs}
																	appliedServices={appliedServices}
																	handleRemoveAdditionalScc={handleRemoveScc}
																	draftCallback={draftCallback}
																	autoAdd={autoAdd}
																	services={services}
																/>
															</div>
														</>
													) : (
														<></>
													)} */}
													{isCopyFlow
														? (
															((shipmentSccs && shipmentSccs.length) || (appliedSccs && appliedSccs.length)) ? (
																<div className="scc-row">
																	<SccListDisplay
																		nonRemovableSccs={[
																			...(shipmentSccs || []),
																			// Filter appliedSccs to only those present in sccMaster
																			...(appliedSccs && appliedSccs.length
																				? appliedSccs.filter(a =>
																					sccMaster.some(m => m.scc === a.scc)
																				)
																				: []
																			)
																		]}
																		additionalSccs={additionalSccs}
																		appliedServices={appliedServices}
																		handleRemoveAdditionalScc={handleRemoveScc}
																		draftCallback={draftCallback}
																		autoAdd={autoAdd}
																		services={services}
																	/>
																</div>
															) : null
														)
														: (
															((shipmentSccs && shipmentSccs.length) ||
																(additionalSccs && additionalSccs.length) ||
																(appliedSccs && appliedSccs.length)) ? (
																<div className="scc-row">
																	<SccListDisplay
																		nonRemovableSccs={[
																			...(shipmentSccs || []),
																			...(appliedSccs || []),
																		]}
																		additionalSccs={additionalSccs}
																		appliedServices={appliedServices}
																		handleRemoveAdditionalScc={handleRemoveScc}
																		draftCallback={draftCallback}
																		autoAdd={autoAdd}
																		services={services}
																	/>
																</div>
															) : null
														)
													}
													<CustomPopup
														footerPriBtnLabel={t("COMMON.OK")}
														footerPriBtnClick={handleConfirm}
														headerComponent={{
															mainHeader: t("COMMON.DATE_HEADER"),
														}}
														body={
															<p>
																{aviBookingDetaills?.[0]?.minBookingDays
																	? t("BOOKING.PET_BOOKING_VALIDATION_TEXT", {
																		days: aviBookingDetaills[0].minBookingDays,
																	})
																	: ""}
															</p>
														}
														isVisible={
															((shippingItem && shippingItem?.code === "DOG") ||
																shippingItem?.code === "CAT") &&
															aviBookingError
														}
														onClose={handleCancel}
													/>
												</div>

												{/* additional shipping */}
												<div
													className={`form-group scc-desktopview common-autocomplete ${recommendedServices?.length ? "mt-0" : ""
														} ${sccWarning ? "red-border" : ""}`}
												>
													<div class="p-float-label input-wrapper">
														<SccAutoComplete
															inputId="additional-style"
															handleAddAdditinalScc={handleAddAdditinalScc}
															clearError={clearError}
															setSccWarning={setSccWarning}
															setNotificationMessage={setNotificationMessage}
															setNotificationType={setNotificationType}
															handleSccChange={handleSccChange}
															setAutoAdd={setAutoAdd}
														/>
														<label htmlFor="additional-style">
															{t("CAPTURE_AWB.ADD_SHC_OPT")}
														</label>
													</div>
													<span className="search-panel__errormsg">
														{sccWarning}
													</span>
												</div>
											</div>

											{isSeasonalBooking ? (
												<></>
											) : (
												<RecommendedSccList
													recommendedSccs={recommendedServices}
													handleAddAdditinalScc={handleAppliedRecommendedScc}
													services={services}
													showWarning={showWarning}
													draftCallback={draftCallback}
												/>
											)}
											<div
												className={`form-group scc-mobile-view common-autocomplete ${recommendedServices?.length ? "mt-0" : ""
													} ${sccWarning ? "red-border" : ""}`}
											>
												<div class="p-float-label input-wrapper">
													<SccAutoComplete
														inputId="additional-style"
														handleAddAdditinalScc={handleAddAdditinalScc}
														clearError={clearError}
														setSccWarning={setSccWarning}
														setNotificationMessage={setNotificationMessage}
														setNotificationType={setNotificationType}
														handleSccChange={handleSccChange}
														setAutoAdd={setAutoAdd}
													/>
													<label htmlFor="additional-style">
														{t("CAPTURE_AWB.ADD_SHC_OPT")}
													</label>
												</div>
												<span className="search-panel__errormsg">
													{sccWarning}
												</span>
											</div>
										</>

										<AlertMessage
											message={
												warning && t(MESSAGES.ADD_SERVICE_INFO, { ns: "errors" })
											}
											onClose={() => setWarning(false)}
											isPopup
										/>

										<AlertMessage
											type="error"
											message={
												sccCombinationError &&
												t(sccCombinationError, { ns: "errors" })
											}
											onClose={() => setSccCombinationError("")}
											isPopup
										/>

										<AlertMessage
											type="error"
											message={!sccCombinationError && sccCompatibilityError}
											onClose={() => setSccCompatibilityError("")}
											isPopup
										/>

										<AlertMessage
											type="error"
											message={shippingTypeError}
											onClose={() => setShippingTypeError("")}
											isPopup
										/>

										{/* Dg booking START */}
										{!isMultipleBookingEdit && (
											<>
												<CustomPopup
													isVisible={
														dgbookcheck &&
														moment(shippingDate) <
														moment()
															.add(
																aviBookingDetaills &&
																aviBookingDetaills?.[1]?.minBookingDays,
																"days"
															)
															.toDate() &&
														!dgBookingError
													}
													footerPriBtnLabel={t("COMMON.OK")}
													footerPriBtnClick={handleConfirm}
													headerComponent={{ mainHeader: t("COMMON.DATE_HEADER") }}
													body={
														<p>
															{t("COMMON.DG_DATE_VAL_MSG", {
																DAYS: aviBookingDetaills?.[1]?.minBookingDays,
															})}
														</p>
													}
													onClose={handleCancel}
												/>

												<CustomPopup
													isVisible={
														dgBookingError &&
														(dgSccCode?.includes(shippingItem?.scc) ||
															shippingItem?.scc === "AVI" ||
															shippingItem === null) &&
														shippingItem?.scc !== "AVI" &&
														shippingItem !== null
													}
													footerPriBtnLabel={t("COMMON.OK")}
													footerPriBtnClick={handleConfirm}
													headerComponent={{ mainHeader: t("COMMON.DATE_HEADER") }}
													body={
														<p>
															{t("COMMON.DG_DATE_VAL_MSG", {
																DAYS: aviBookingDetaills?.[1]?.minBookingDays,
															})}
														</p>
													}
													onClose={handleCancel}
												/>

												{dgSccCode?.includes(shippingItem?.scc) ||
													shippingItem?.scc === "AVI" ||
													shippingItem?.scc === "AVI" ||
													shippingItem === null ? (
													<></>
												) : (
													<>
														<div
															className={
																gradeoutQ
																	? `is-disabled  cargo-additional-dg-style-row`
																	: "cargo-additional-dg-style-row"
															}
														>
															<div className="top-section">
																<div className="d-flex align-items-center">
																	<img
																		className="dg-info"
																		src={errorFilledOrange}
																		alt="info"
																		title="dg-info"
																	/>
																	<label className="dg-label">
																		{t("COMMON.VALIDATE_GOODS")}
																	</label>
																</div>

																<RadioToggle
																	checkedArray={[dgbookcheck, !dgbookcheck]}
																	valueArray={["Yes", "No"]}
																	labelArray={["COMMON.YES", "COMMON.NO"]}
																	className="dg-check-toggle"
																	onChangeArray={[
																		() => {
																			setDgbookcheck(true);
																			setHasDangerous(true);
																			setToSessionStorage("ifDg", true);
																		},
																		(e) => {
																			setDgbookcheck(false);
																			setUnidName("");
																			setUnid("");
																			{
																				setSpecialProvisonErrorCheck(true);
																			}
																			setUnidList([getInitUnidDetail()]);
																			setHasDangerous(false);
																			setToSessionStorage("ifDg", false);
																		},
																	]}
																/>
															</div>

														</div>
													</>
												)}

												{(dgSccCode?.includes(shippingItem?.scc) ||
													dgbookcheck) && (
														<>
															{/* multi ui implementation */}
															{!aviBookingError && shippingItem !== null && (
																<div className="cargo-additional-dg-style-row">
																	<div className="dg-multi-unid-container w-100">
																		{setToSessionStorage("ifDg", true)}
																		<DgMultiUnidContainer
																			autoCompleteType={AUTOCOMPLETE_UNID.UNID}
																			handleClear={handleClear}
																			selectedDestination={selectedDestination}
																			selectedOrigin={selectedOrigin}
																			shippingDate={shippingDate}
																			shippingItem={shippingItem}
																			setIsLoading={setIsLoading}
																			searchFormData={searchFormData}
																			isModifyBooking={isModifyBooking}
																			setShippingItem={setShippingItem}
																			file={file}
																			setFile={setFile}
																			draftCallback={draftCallback}
																			error={error}
																			setUnidWarning={setUnidWarning}
																			clearError={clearError}
																			setSccWarning={setSccWarning}
																			setNotificationMessage={
																				setNotificationMessage
																			}
																			setNotificationType={setNotificationType}
																			handleSccChange={handleSccChange}
																			setUnidName={setUnidName}
																			setUnid={setUnid}
																			unid={unid}
																			unidName={unidName}
																			setSpecialProvison={setSpecialProvison}
																			specialProvison={specialProvison}
																			specailProvialMessage={
																				specailProvialMessage
																			}
																			additionalSccs={additionalSccs}
																			setUnidList={setUnidList}
																			unidList={unidList}
																			setCargoFlights={setCargoFlights}
																			cargoFlights={cargoFlights}
																			handleAddAdditinalScc={
																				handleAddAdditinalScc
																			}
																			handleRemoveAdditionalScc={handleRemoveScc}
																			setShipmentSccs={setShipmentSccs}
																			shipmentSccs={shipmentSccs}
																			setIsCAOChecked={setIsCAOChecked}
																			isCAOChecked={isCAOChecked}
																			setAutoAdd={setAutoAdd}
																			autoAdd={autoAdd}
																			setAdditionalSccs={setAdditionalSccs}
																			setExceptionTypeDg={setExceptionTypeDg}
																			exceptionTypeDg={exceptionTypeDg}
																			setSpUnid={setSpUnid}
																			appliedSccs={appliedSccs}
																			setAppliedSccs={setAppliedSccs}
																			unidSccList={unidSccList}
																			setUnidSccList={setUnidSccList}
																			unidArray={unidArray}
																			additionalInfoData={additionalInfoData}
																			setAdditionalInfoData={
																				setAdditionalInfoData
																			}
																			displayDgValidationPopup={
																				displayDgValidationPopup
																			}
																			setDisplayDgValidationPopup={
																				setDisplayDgValidationPopup
																			}
																			popupNotificationPopup={
																				popupNotificationPopup
																			}
																			spUnid={spUnid}
																			setEmbargoErrorCheck={setEmbargoErrorCheck}
																			setSpecialProvisonErrorCheck={
																				setSpecialProvisonErrorCheck
																			}
																		/>
																	</div>
																</div>
															)}
														</>
													)}
											</>
										)}
										{/* Dg booking ENDS */}

										{/* AVI booking */}
										{(shippingItem?.code === "DOG" ||
											shippingItem?.code === "CAT") &&
											!aviBookingError ? (
											<>
												<MultiplePetsContainer
													displayShippingItemPopup={displayShippingItemPopup}
													setDisplayShippingItemPopup={
														setDisplayShippingItemPopup
													}
													handleClear={handleClear}
													selectedDestination={selectedDestination}
													selectedOrigin={selectedOrigin}
													shippingDate={shippingDate}
													shippingItem={shippingItem}
													setIsLoading={setIsLoading}
													setNotificationMessage={setNotificationMessage}
													setNotificationType={setNotificationType}
													setShippingItem={setShippingItem}
													additionalSccs={additionalSccs}
													// setPetList={setPetList}
													// petList={petList}
													file={file}
													setFile={setFile}
													dogBreeds={dogBreeds}
													searchFormData={searchFormData}
													setArrayListDoc={setArrayListDoc}
													arrayListDoc={arrayListDoc}
													setCageList={setCageLists}
													cageList={cageList}
													setDeletedCageIds={setDeletedCageIds}
													deletedCageIds={deletedCageIds}
													setDeletedPetIds={setDeletedPetIds}
													deletedPetIds={deletedPetIds}
													error={error}
													setError={setError}
													weightUnit={weightUnit}
													dimensionUnit={dimensionUnit}
													setDimensionUnit={setDimensionUnit}
													setWeightUnit={setWeightUnit}
													stubNose={stubNose}
													setStubNose={setStubNose}
													breedRejected={breedRejected}
													setBreedRejected={setBreedRejected}
													setTotalPieces={setTotalPieces}
												/>
											</>
										) : null}

										<AdditionalInfoForm
											shippingItem={shippingItem}
											appliedSccs={appliedSccs}
											setAppliedSccs={setAppliedSccs}
											additionalInfoData={additionalInfoData}
											setAdditionalInfoData={setAdditionalInfoData}
											error={error}
											setError={setError}
											setDisplayContainerPopup={setDisplayContainerPopup}
											additionalSccs={additionalSccs}
											setAdditionalSccs={setAdditionalSccs}
											sccCombinationError={sccCombinationError}
											setSccCombinationError={setSccCombinationError}
											handleAppliedAddScc={handleAppliedAddScc}
											sccCompatibility={sccCompatibility}
											setSccCompatibility={setSccCompatibility}
											setHandlingInformation={setHandlingInformation}
											handlingInformation={handlingInformation}
											sccInputChanged={sccInputChanged}
											setSccInputChanged={setSccInputChanged}
										/>
										{isUSBound ? (
											<div className="cargo-looseuld-row position-relative">
												<label className="sub-head-label">
													{t("BOOKING.UNKNWN_SHPR")}
												</label>
												<RadioToggle
													className="shipper-type-radio"
													valueArray={[
														IS_KNOWN_UNKNOWN.KNOWN,
														IS_KNOWN_UNKNOWN.UNKNOWN,
													]}
													labelArray={unkownShipperSelectItems.map(
														(e) => e.label
													)}
													checkedArray={[
														isUnknownShipment === false,
														isUnknownShipment === true,
													]}
													onChangeArray={[
														() => {
															clearError(FORM_FIELDS.UNKNOWN_SHIPMENT);
															setIsUnknownShipment(false);
														},
														(e) => {
															clearError(FORM_FIELDS.UNKNOWN_SHIPMENT);
															setIsUnknownShipment(true);
														},
													]}
												/>
												<span className="common-input-error">
													{error && error[FORM_FIELDS.UNKNOWN_SHIPMENT]
														? t(error[FORM_FIELDS.UNKNOWN_SHIPMENT], {
															ns: "errors",
														})
														: ""}
												</span>
											</div>
										) : (
											<></>
										)}
										{shippingItem?.code !== "DOG" &&
											shippingItem?.code !== "CAT" ? (
											<div className="cargo-looseuld-row">
												<label className="sub-head-label">
													{t("BOOKING.CARGO_LABEL")}
												</label>
												<RadioToggle
													checkedArray={[
														shippingType === "LOOSE",
														shippingType === "ULD",
													]}
													valueArray={["LOOSE", "ULD"]}
													labelArray={["Loose", "ULD"]}
													className="shipping-type-toggle"
													disabled={isBupSccPresent}
													onChangeArray={[
														() => {
															if (isBupSccPresent) {
																setShippingTypeError(`BUP (SHC) is allowed only for ULD bookings.`);
																setTimeout(() => setShippingTypeError(''), 5000);
																return;
															}
															setShippingType("LOOSE");
															setExceptionTypeDg();
															setDisplayDgULDItemPopup(false);
															setDgEnabled(false);
														},
														(e) => {
															setShippingType("ULD");
															setDisplayDgULDItemPopup(false);

															if (
																(dgSccCode?.includes(shippingItem?.scc) &&
																	e.target.value === "ULD") ||
																(e.target.value === "ULD" && dgbookcheck)
															) {
																setDisplayDgULDItemPopup(true);
																setDgEnabled(true);
																setExceptionTypeDg("DG_ULD");
															}
														},
													]}
												/>
											</div>
										) : (
											""
										)}
										<>
											{shippingItem?.code !== "DOG" &&
												shippingItem?.code !== "CAT" ? (
												<>
													{shippingType === "LOOSE" ? (
														<LooseItemForm
															looseDetails={looseDetails}
															setLooseDetails={setLooseDetails}
															totalWeight={looseItemsTotalWeight}
															setTotalWeight={setLooseItemsTotalWeight}
															setLooseItemsGrossWeight={setLooseItemsGrossWeight}
															weightUnit={weightUnit}
															setWeightUnit={setWeightUnit}
															dimensionUnit={dimensionUnit}
															setDimensionUnit={setDimensionUnit}
															isAllStackable={isAllStackable}
															setAllStackable={setAllStackable}
															isAllTiltable={isAllTiltable}
															setAllTiltable={setAllTiltable}
															handleAddLineItem={handleAddLineItem}
															setTotalPieces={setTotalPieces}
															setTotalVolumeInMeters={setTotalVolumeInMeters}
															setChargeableWeight={setChargeableWeight}
															setChargeableWeightInSelectedUnit={
																setChargeableWeightInSelectedUnit
															}
															setTotalWeightInKg={setTotalWeightInKg}
															totalWeightInKilo={totalWeightInKg}
															totalVolumeinMtrs={totalVolumeInMtrs}
															error={error}
															setError={setError}
															calculatedTotalWeight={calculatedTotalWeight}
															setCalculatedTotalWeight={setCalculatedTotalWeight}
															setActualVolume={setActualVolume}
															setActualChargeableWeight={
																setActualChargeableWeight
															}
															setActualGrossWeight={setActualGrossWeight}
															actualTotalIneItemWeight={actualTotalIneItemWeight}
															setActualTotalIneItemWeight={
																setActualTotalIneItemWeight
															}
															draftCallback={draftCallback}
															adjustedWeight={adjustedWeight}
															setAdjustedWeight={setAdjustedWeight}
															showOpWeight={showOpWeight}
															setShowOpweight={setShowOpweight}
															AviEnabled={
																shippingItem?.code === "DOG" ||
																	shippingItem?.code === "CAT"
																	? true
																	: false
															}
															isMultipleBookingEdit={isMultipleBookingEdit}
														/>
													) : (
														<ULDItemForm
															ULDDetails={ULDDetails}
															setULDDetails={setULDDetails}
															weightUnit={weightUnit}
															setWeightUnit={setWeightUnit}
															dimensionUnit={dimensionUnit}
															setDimensionUnit={setDimensionUnit}
															handleAddLineItem={handleAddLineItem}
															setTotalPieces={setTotalPieces}
															setTotalVolumeInMeters={setTotalVolumeInMeters}
															setTotalWeightInKg={setTotalWeightInKg}
															totalWeightInKilo={totalWeightInKg}
															setChargeableWeight={setChargeableWeight}
															setChargeableWeightInSelectedUnit={
																setChargeableWeightInSelectedUnit
															}
															error={error}
															setError={setError}
															searchFormData={searchFormData}
															mixLooseDetails={mixLooseDetails}
															setMixLooseDetails={setMixLooseDetails}
															selectedOrigin={selectedOrigin}
															expandAccordian={expandAccordian}
															setExpandAccordian={setExpandAccordian}
															setActualVolume={setActualVolume}
															setActualGrossWeight={setActualGrossWeight}
															draftCallback={draftCallback}
															setNotificationMessage={setNotificationMessage}
															setNotificationType={setNotificationType}
															DgEnabled={dgEnabled}
															setDisplayDgULDItemPopup={setDisplayDgULDItemPopup}
															isMultipleBookingEdit={isMultipleBookingEdit}
														/>
													)}
													{dgSccCode?.includes(shippingItem?.scc) ||
														(dgbookcheck && !isSeasonalBooking) ? (
														<div className="dg-doc-upload-session">
															<label className="upload-main-head">
																{t("COMMON.DG_DOCUMENTS")}
															</label>
															<div className="dg-upload-body">
																<div className="upload-doc-label-info">
																	<label className="upload-doc-label">
																		{dgarrayListDoc.length > 0
																			? `${t("COMMON.FILE_DG_UPLOADED")}`
																			: `${t("COMMON.UPLOAD_RELEVANT")}`}
																	</label>
																	<img
																		src={infoicon}
																		onClick={handelPopup}
																		alt="Allowed list"
																		title="Allowed list"
																		className="upload-doc-icon"
																	/>
																</div>

																<CustomPopup
																	isVisible={displayDglist}
																	footerPriBtnLabel={t("COMMON.OK")}
																	footerPriBtnClick={closeDialog}
																	headerComponent={{
																		mainHeader: t("COMMON.DOC_REQUIRED"),
																	}}
																	onClose={closeDialog}
																	body={
																		<ul
																			className="ml-4"
																			style={{ listStyle: "disc" }}
																		>
																			<li>{t("BOOKING.DG_LABEL")}</li>
																			<li>{t("BOOKING.LICPER_LABEL")}</li>
																		</ul>
																	}
																/>
																{file?.length > 0 ||
																	dgarrayListDoc?.length > 0 ? (
																	<ul className="dg-up-file-list">
																		{dgarrayListDoc?.map((element, i) => {
																			const filArraypath =
																				element?.fileName?.split(".");
																			return (
																				<li className="dg-up-file">
																					<div
																						className="up-file-details"
																						key={i}
																					>
																						<img
																							src={
																								filArraypath &&
																									filArraypath[1] === "pdf"
																									? pdf
																									: (filArraypath &&
																										filArraypath[1] ===
																										"xlsx") ||
																										(filArraypath &&
																											filArraypath[1] === "xls")
																										? excel
																										: filArraypath &&
																											filArraypath[1] === "docx"
																											? word
																											: (filArraypath &&
																												filArraypath[1] ===
																												"png") ||
																												(filArraypath &&
																													filArraypath[1] ===
																													"jpeg") ||
																												(filArraypath &&
																													filArraypath[1] === "jpg")
																												? walpaper
																												: document
																							}
																							alt={
																								filArraypath && filArraypath[1]
																							}
																							title={
																								filArraypath && filArraypath[1]
																							}
																						/>
																						<span> {element.fileName}</span>
																					</div>
																					<span
																						className="up-file-delete"
																						onClick={(e) =>
																							handleRemovedg(element, i)
																						}
																					>
																						{t("COMMON.DELETE")}
																					</span>
																				</li>
																			);
																		})}
																	</ul>
																) : (
																	<></>
																)}

																<DgdocUpload
																	id={"dgUpload"}
																	setDisplayUploadSection={
																		setDisplayUploadSection
																	}
																	fileName={fileName}
																	onCommodityChange={onCommodityChange}
																	setOnCommodityChange={setOnCommodityChange}
																	file={file}
																	unid={unid}
																	setUnid={setUnid}
																	setFile={setFile}
																	fileCount={dgarrayListDoc[0] ? true : false}
																	dgarrayListDoc={dgarrayListDoc}
																	searchFormData={searchFormData}
																	setIsLoading={setIsLoading}
																/>
															</div>
														</div>
													) : (
														<></>
													)}
												</>
											) : (
												<></>
											)}
										</>
									</div>
								</div>

								{/* Promotion container */}

								<div className="promotion-container-row">
									<h3>{t("BOOKING.PROMOTION")}</h3>
									<div className="form-container">
										<RadioToggle
											checkedArray={[
												priceCodeType === PRICE_CODE_TYPE.PROMO_RATE,
												priceCodeType === PRICE_CODE_TYPE.SPOT_RATE,
											]}
											valueArray={[
												PRICE_CODE_TYPE.PROMO_RATE,
												PRICE_CODE_TYPE.SPOT_RATE,
											]}
											labelArray={["BOOKING.PROMO_CODE", "BOOKING.SPOT_ID"]}
											className="promotion-toggle"
											onChangeArray={[
												(e) => {
													setPriceCodeType(e.target.value);
												},
												(e) => {
													setPriceCodeType(e.target.value);
												},
											]}
										/>

										<div className="form-group mb-1">
											<CommonInput
												id="promotion-code-input"
												label={`${priceCodeType === PRICE_CODE_TYPE.PROMO_RATE
													? t('BOOKING.PROMO_CODE_PLACEHOLDER')
													: t('BOOKING.SPOT_ID_PLACEHOLDER')
													}`}
												type="text"
												value={
													priceCodeType === PRICE_CODE_TYPE.PROMO_RATE
														? promoCode
														: spotRateCode
												}
												onChange={({ target }) => {
													if (!target) return;
													if (
														(target.value && target.value.length > 20) ||
														target.value.trim().split(" ").length > 1
													) {
														handleSetError(
															FORM_FIELDS.PRICE_CODE,
															`Enter valid ${priceCodeType === PRICE_CODE_TYPE.PROMO_RATE
																? t('BOOKING.PROMO_CODE')
																: t('BOOKING.SPOT_ID')
															}`
														);
													} else {
														handleSetError(FORM_FIELDS.PRICE_CODE, null);
													}
													if (priceCodeType === PRICE_CODE_TYPE.PROMO_RATE) {
														setPromoCode(target.value.toUpperCase());
													} else {
														setSpotRateCode(target.value);
													}
												}}
												error={
													error && error[FORM_FIELDS.PRICE_CODE]
														? error[FORM_FIELDS.PRICE_CODE]
														: ""
												}
											/>
										</div>
									</div>
								</div>
								{!isMultipleBookingEdit && (
									<SearchSummary
										totalPieces={totalPieces}
										weightUnit={weightUnit}
										dimensionUnit={dimensionUnit}
										totalWeightInKg={totalWeightInKg}
										totalVolumeInMtrs={totalVolumeInMtrs}
										chargeableWeight={chargeableWeight}
										looseDetails={looseDetails}
										shippingType={shippingType}
										totalWeight={looseItemsTotalWeight}
										looseItemsGrossWeight={looseItemsGrossWeight}
										calculatedTotalWeight={calculatedTotalWeight}
										actualGrossWeight={actualGrossWeight}
										actualTotalIneItemWeight={actualTotalIneItemWeight}
										actualVolume={actualVolume}
										actualChargeableWeight={actualChargeableWeight}
										setGrossWeightInSelectedUnit={setGrossWeightInSelectedUnit}
										setGrossWeightInConvertedUnit={setGrossWeightInConvertedUnit}
										setDensityInSelectedUnit={setDensityInSelectedUnit}
										setdensityInConvertedUnit={setdensityInConvertedUnit}
										chargeableWeightInSelectedUnit={
											chargeableWeightInSelectedUnit
										}
										cageList={cageList}
										shippingItem={shippingItem}
										AviEnabled={
											shippingItem?.code === "DOG" || shippingItem?.code === "CAT"
												? true
												: false
										}
										cages={cageList}
									/>
								)}

								<AlertMessage
									type="error"
									message={
										footerErrorMsg ? t(footerErrorMsg, { ns: "errors" }) : ""
									}
									className="my-3"
									onClose={() => setFooterErrorMsg("")}
									isPopup
								/>

								<div className="footer-section-row">
									{isSeasonalBooking ? (
										<SeasonalButtonGroup
											handleSubmit={submitSeasonalBookingForm}
											handleClearSeasonal={handleClearSeasonal}
											setSelectedTemplate={setSelectedTemplate}
											setNotLeave={setNotLeave}
										/>
									) : (
										<SearchButtonGroup
											setNotLeave={setNotLeave}
											setSelectedTemplate={setSelectedTemplate}
											selectedTemplate={selectedTemplate}
											handleClear={handleClear}
											updateTemplateView={updateTemplateView}
											templateView={templateView}
											templateName={templateName}
											setTemplateName={setTemplateName}
											handleSubmit={handleSubmit}
											handleSaveTemplate={handleSaveTemplate}
											templateModal={templateModal}
											setTemplateModal={setTemplateModal}
											saveTempError={saveTempError}
											setSaveTempError={setSaveTempError}
											isModifyBooking={isModifyBooking}
											awbNo={awbNo}
											stubNose={stubNose}
											breedRejected={breedRejected}
											isSeasonalBooking={isSeasonalBooking}
											setIsLoading={setIsLoading}
											isMultipleBookingEdit={isMultipleBookingEdit}
											handleMutlipleBookSaveChange={handleMutlipleBookSaveChange}
										/>
									)}
								</div>
							</form>
						)}

					{/* Container Validation Popup */}
					<ContainerValidationPopUp
						additionalInfoData={additionalInfoData}
						setAdditionalInfoData={setAdditionalInfoData}
						displayContainerPopup={displayContainerPopup}
						setDisplayContainerPopup={setDisplayContainerPopup}
						handleClear={handleClear}
						selectedDestination={selectedDestination}
						selectedOrigin={selectedOrigin}
						shippingDate={shippingDate}
						shippingItem={shippingItem}
						setIsLoading={setIsLoading}
						setNotificationMessage={setNotificationMessage}
						setNotificationType={setNotificationType}
						additionalSccs={additionalSccs}
					/>

					{/* Shipping Item Validation Popup */}
					<ShippingItemValidationPopUp
						displayShippingItemPopup={
							displayShippingItemPopup &&
							shippingItem?.code !== "DOG" &&
							shippingItem?.code !== "CAT" &&
							shippingItem?.scc !== "AVI" &&
							!dgSccCode?.includes(shippingItem?.scc) &&
							shippingItem !== null
						}
						setDisplayShippingItemPopup={setDisplayShippingItemPopup}
						handleClear={handleClear}
						selectedDestination={selectedDestination}
						selectedOrigin={selectedOrigin}
						shippingDate={shippingDate}
						shippingItem={shippingItem}
						setIsLoading={setIsLoading}
						setNotificationMessage={setNotificationMessage}
						setNotificationType={setNotificationType}
						setShippingItem={setShippingItem}
						additionalSccs={additionalSccs}
					/>

					{/* AVI Shipping Item Validation Popup */}
					<AviShippingItemValidationPopUp
						displayShippingItemPopup={
							displayShippingItemPopup &&
							shippingItem?.code !== "DOG" &&
							shippingItem?.code !== "CAT" &&
							shippingItem?.scc === "AVI"
						}
						setDisplayShippingItemPopup={setDisplayShippingItemPopup}
						handleClear={handleClear}
						selectedDestination={selectedDestination}
						selectedOrigin={selectedOrigin}
						shippingDate={shippingDate}
						shippingItem={shippingItem}
						setIsLoading={setIsLoading}
						setNotificationMessage={setNotificationMessage}
						setNotificationType={setNotificationType}
						setShippingItem={setShippingItem}
						additionalSccs={additionalSccs}
					/>

					{/* ULD Validation Popup */}
					<UldValidationPopupdg
						setDisplayDgULDItemPopup={setDisplayDgULDItemPopup}
						displayDgULDItemPopup={
							displayDgULDItemPopup &&
							(dgSccCode?.includes(shippingItem?.scc) || dgbookcheck)
						}
						handleClear={handleClear}
						selectedDestination={selectedDestination}
						selectedOrigin={selectedOrigin}
						shippingDate={shippingDate}
						shippingItem={shippingItem}
						setIsLoading={setIsLoading}
						setNotificationMessage={setNotificationMessage}
						setNotificationType={setNotificationType}
						additionalSccs={additionalSccs}
						popupNotificationPopup={popupNotificationPopup}
						// setUnidSelectedValidation={setUnidSelectedValidation}
						spUnid={spUnid}
						specialProvison={specialProvison}
						exceptionTypeDg={exceptionTypeDg}
						setExceptionTypeDg={setExceptionTypeDg}
						// setSpUnid={setSpUnid}
						unidList={unidList}
						setShippingType={setShippingType}
					/>

					{/* Booking Restriction Popup */}
					<CustomPopup
						isVisible={bookingRestrictionError}
						footerPriBtnLabel={t("COMMON.OK")}
						footerPriBtnClick={onCloseRussianResPopup}
						onClose={onCloseRussianResPopup}
						headerComponent={{ mainHeader: t("COMMON.SP_VALID_RESTRICTED") }}
						body={<p>{errorMessage}</p>}
					/>
					{isLoading ? <LoadingIndicator /> : <></>}
				</div>
			}
		/>
	);
};

export default SearchPanel;
